import { useRef } from "react";
import "./main.css";
import dayjs from "dayjs";

export const RamadanAnimation = () => {
  const audioRef = useRef(
    new Audio(
      "https://github.com/mukhammadjcn/sources/raw/main/audio/ramadan-cutted.mp3"
    )
  ); // audio faylini yo'lini kiriting

  const playAudio = () => {
    audioRef.current.currentTime = 0; // har safar boshidan o'ynaydi
    audioRef.current.play().catch((e) => console.log("Audio play error:", e));
  };

  const stopAudio = () => {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  };

  const today = dayjs(); // Hozirgi sana
  const deadline = dayjs("2025-03-30"); // 30-martni o'rnatamiz

  // Agar bugungi sana 30-martdan keyin bo'lsa, component ko'rinmaydi
  if (today.isAfter(deadline)) {
    return null; // Component hech narsa return qilmaydi => ekranda ko'rinmaydi
  }

  // Aks holda, oddiy component ko'rinadi
  return (
    <div
      className="ramadanLantern"
      onMouseEnter={playAudio}
      onMouseLeave={stopAudio}
    >
      <a
        href="https://www.gazeta.uz/oz/ramadan"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 145.3 206.6"
        >
          <g id="circle">
            <radialGradient
              id="SVGID_1_"
              cx="-418.0545"
              cy="602.1006"
              r="1"
              gradientTransform="matrix(53.4839 0 0 -53.6071 22489.8945 32368.1055)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: " #FFFFFF" }} />
              <stop offset="0.2982" style={{ stopColor: "#FAFAFA" }} />
              <stop offset="0.6473" style={{ stopColor: "#ECECEC" }} />
              <stop offset="1" style={{ stopColor: "#D6D6D6" }} />
            </radialGradient>
            <path
              className="st0"
              d="M123.5,88.9H106l-12.3,12.4v17.5l12.3,12.4h17.5l12.3-12.4v-17.5L123.5,88.9z"
            />
            <path
              className="st1"
              d="M123.2,89.5h-17l-12,12v17l12,12h17l12-12v-17L123.2,89.5z"
            />
            <path
              className="st2"
              d="M122.1,92.1h-14.8l-10.5,10.5v14.8l10.5,10.5h14.8l10.5-10.5v-14.8L122.1,92.1z"
            />
            <path
              className="st3"
              d="M122.1,128.5h-14.8c-0.1,0-0.2-0.1-0.4-0.1l-10.5-10.5c-0.1-0.1-0.1-0.2-0.1-0.4v-14.8c0-0.1,0.1-0.2,0.1-0.4
            l10.5-10.5c0.1-0.1,0.2-0.1,0.4-0.1h14.8c0.1,0,0.2,0.1,0.4,0.1l10.5,10.5c0.1,0.1,0.1,0.2,0.1,0.4v14.8c0,0.1-0.1,0.2-0.1,0.4
            l-10.5,10.5C122.4,128.4,122.3,128.5,122.1,128.5z M107.5,127.4h14.4l10.2-10.2v-14.4l-10.2-10.2h-14.4l-10.2,10.2v14.4
            L107.5,127.4z"
            />
            <path
              className="st3"
              d="M114.7,128.5c-0.1,0-0.2-0.1-0.3-0.1l-7.5-6.1c-0.1-0.1-0.2-0.2-0.2-0.4V98.5c0-0.1,0.1-0.3,0.2-0.4l7.5-6.1
            c0.2-0.2,0.4-0.2,0.7,0l7.5,6.1c0.1,0.1,0.2,0.2,0.2,0.4v23.4c0,0.1-0.1,0.3-0.2,0.4l-7.5,6.1C114.9,128.4,114.8,128.5,114.7,128.5
            z M107.8,121.5l7,5.8l7-5.8V98.6l-7-5.8l-7,5.8V121.5z"
            />
            <path
              className="st3"
              d="M126.4,118h-23.3c-0.1,0-0.3-0.1-0.4-0.2l-6.2-7.5c-0.2-0.2-0.2-0.4,0-0.7l6.1-7.5c0.1-0.1,0.2-0.2,0.4-0.2
            h23.3c0.1,0,0.3,0.1,0.4,0.2l6.1,7.5c0.2,0.2,0.2,0.4,0,0.7l-6.1,7.5C126.6,118,126.5,118,126.4,118z M103.3,117h22.8l5.8-7l-5.8-7
            h-22.8l-5.8,7L103.3,117z"
            />
            <path
              className="st3"
              d="M111.7,124.1l-9.7-0.9c-0.2,0-0.4-0.2-0.4-0.4l-0.9-9.6c0-0.1,0.1-0.3,0.1-0.4l16.5-16.5
            c0.1-0.1,0.2-0.2,0.4-0.1l9.6,0.9c0.2,0,0.4,0.2,0.4,0.4l0.9,9.6c0,0.1-0.1,0.3-0.1,0.4L112.1,124
            C112,124.1,111.9,124.1,111.7,124.1z M102.6,122.3l9,0.8l16.2-16.2l-0.8-9l-9-0.8l-16.2,16.2L102.6,122.3z"
            />
            <path
              className="st3"
              d="M117.7,124.1c-0.1,0-0.2-0.1-0.4-0.1l-16.5-16.5c-0.1-0.1-0.2-0.2-0.1-0.4l0.9-9.6c0-0.2,0.2-0.4,0.4-0.4
            l9.6-0.9c0.1,0,0.3,0.1,0.4,0.1l16.5,16.5c0.1,0.1,0.2,0.2,0.1,0.4l-0.9,9.6c0,0.2-0.2,0.4-0.4,0.4L117.7,124.1
            C117.7,124.1,117.7,124.1,117.7,124.1z M101.8,106.9l16.2,16.2l9-0.8l0.8-9l-16.2-16.2l-9,0.8L101.8,106.9z"
            />
          </g>
          <g id="circle5">
            <radialGradient
              id="SVGID_2_"
              cx="-417.841"
              cy="601.9047"
              r="1"
              gradientTransform="matrix(52.1222 0 0 -52.2423 21840.6562 31570.4766)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: " #FFFFFF" }} />
              <stop offset="0.2982" style={{ stopColor: "#FAFAFA" }} />
              <stop offset="0.6473" style={{ stopColor: "#ECECEC" }} />
              <stop offset="1" style={{ stopColor: "#D6D6D6" }} />
            </radialGradient>
            <path
              className="st4"
              d="M54.8,123.4h-17l-12,12v17l12,12h17l12-12v-17L54.8,123.4z"
            />
            <path
              className="st1"
              d="M54.5,123.9H38l-11.7,11.7v16.6L38,164h16.5l11.7-11.7v-16.6L54.5,123.9z"
            />
            <path
              className="st2"
              d="M53.5,126.5H39.1l-10.2,10.2v14.5l10.2,10.2h14.4l10.2-10.2v-14.5L53.5,126.5z"
            />
            <path
              className="st5"
              d="M53.4,161.8H39.1c-0.1,0-0.2-0.1-0.4-0.1l-10.2-10.2c-0.1-0.1-0.1-0.2-0.1-0.4v-14.4c0-0.1,0.1-0.2,0.1-0.4
            l10.2-10.2c0.1-0.1,0.2-0.1,0.4-0.1h14.4c0.1,0,0.2,0.1,0.4,0.1L64,136.4c0.1,0.1,0.1,0.2,0.1,0.4v14.4c0,0.1-0.1,0.2-0.1,0.4
            l-10.2,10.2C53.7,161.8,53.6,161.8,53.4,161.8z M39.3,160.9h14l9.9-9.9v-14l-9.9-9.9h-14l-9.9,9.9v14L39.3,160.9z"
            />
            <path
              className="st5"
              d="M46.3,161.8c-0.1,0-0.2-0.1-0.3-0.1l-7.3-6c-0.1-0.1-0.2-0.2-0.2-0.4v-22.8c0-0.1,0.1-0.3,0.2-0.4l7.3-6
            c0.2-0.1,0.4-0.1,0.6,0l7.3,6c0.1,0.1,0.2,0.2,0.2,0.4v22.8c0,0.1-0.1,0.3-0.2,0.4l-7.3,6C46.5,161.8,46.4,161.8,46.3,161.8z
             M39.5,155.1l6.8,5.6l6.8-5.6v-22.3l-6.8-5.6l-6.8,5.6V155.1z"
            />
            <path
              className="st5"
              d="M57.6,151.7H34.9c-0.1,0-0.3-0.1-0.4-0.2l-6-7.3c-0.1-0.2-0.1-0.4,0-0.6l6-7.3c0.1-0.1,0.2-0.2,0.4-0.2h22.7
            c0.1,0,0.3,0.1,0.4,0.2l6,7.3c0.1,0.2,0.1,0.4,0,0.6l-6,7.3C57.9,151.6,57.8,151.7,57.6,151.7z M35.2,150.7h22.2l5.6-6.8l-5.6-6.8
            H35.2l-5.6,6.8L35.2,150.7z"
            />
            <path
              className="st5"
              d="M43.3,157.6l-9.4-0.8c-0.2,0-0.4-0.2-0.4-0.4l-0.9-9.4c0-0.1,0.1-0.3,0.1-0.4l16-16.1c0.1-0.1,0.2-0.2,0.4-0.1
            l9.4,0.9c0.2,0,0.4,0.2,0.4,0.4l0.9,9.4c0,0.1-0.1,0.3-0.1,0.4l-16,16.1C43.6,157.5,43.5,157.6,43.3,157.6z M34.5,155.8l8.7,0.8
            l15.7-15.8l-0.8-8.8l-8.8-0.8l-15.7,15.8L34.5,155.8z"
            />
            <path
              className="st5"
              d="M49.2,157.6c-0.1,0-0.2-0.1-0.4-0.1l-16-16.1c-0.1-0.1-0.2-0.2-0.1-0.4l0.9-9.4c0-0.2,0.2-0.4,0.4-0.4l9.4-0.9
            c0.1,0,0.3,0.1,0.4,0.1l16,16.1c0.1,0.1,0.2,0.2,0.1,0.4l-0.9,9.4c0,0.2-0.2,0.4-0.4,0.4L49.2,157.6
            C49.2,157.6,49.2,157.6,49.2,157.6z M33.6,140.9l15.7,15.8l8.8-0.8l0.8-8.7l-15.7-15.8l-8.8,0.8L33.6,140.9z"
            />
          </g>
          <g id="circle4">
            <radialGradient
              id="SVGID_3_"
              cx="-421.558"
              cy="605.3161"
              r="1"
              gradientTransform="matrix(93.6327 0 0 -93.8484 39567.9609 56876.4844)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: " #FFFFFF" }} />
              <stop offset="0.2982" style={{ stopColor: "#FAFAFA" }} />
              <stop offset="0.6473" style={{ stopColor: "#ECECEC" }} />
              <stop offset="1" style={{ stopColor: "#D6D6D6" }} />
            </radialGradient>
            <path
              className="st6"
              d="M83.6,64.5H53.1L31.4,86.2v30.6l21.6,21.7h30.5l21.6-21.7V86.2L83.6,64.5z"
            />
            <path
              className="st1"
              d="M83.2,65.6H53.5l-21,21.1v29.8l21,21.1h29.7l21-21.1V86.7L83.2,65.6z"
            />
            <path
              className="st2"
              d="M81.3,70.1h-26L37,88.5v26l18.3,18.4h26l18.3-18.4v-26L81.3,70.1z"
            />
            <path
              className="st7"
              d="M81.3,133.6H55.4c-0.2,0-0.5-0.1-0.6-0.2l-18.3-18.3c-0.2-0.2-0.2-0.4-0.2-0.6V88.6c0-0.2,0.1-0.5,0.2-0.6
            l18.3-18.3c0.2-0.2,0.4-0.2,0.6-0.2h25.8c0.2,0,0.5,0.1,0.6,0.2L100.1,88c0.2,0.2,0.2,0.4,0.2,0.6v25.9c0,0.2-0.1,0.5-0.2,0.6
            l-18.3,18.3C81.7,133.6,81.5,133.6,81.3,133.6z M55.8,131.9h25.1l17.7-17.8V88.9L80.9,71.2H55.8L38.1,88.9v25.2L55.8,131.9z"
            />
            <path
              className="st7"
              d="M68.3,133.6c-0.2,0-0.4-0.1-0.5-0.2l-13-10.8c-0.2-0.2-0.3-0.4-0.3-0.7V81.1c0-0.2,0.1-0.5,0.3-0.7l13-10.8
            c0.3-0.2,0.8-0.2,1.1,0l13,10.8c0.2,0.2,0.3,0.4,0.3,0.7V122c0,0.2-0.1,0.5-0.3,0.7l-13,10.8C68.8,133.6,68.5,133.6,68.3,133.6z
             M56.2,121.6l12.1,10.1l12.1-10.1V81.5L68.3,71.4L56.2,81.5V121.6z"
            />
            <path
              className="st7"
              d="M88.8,115.4H47.9c-0.2,0-0.5-0.1-0.7-0.3l-10.8-13.1c-0.2-0.3-0.2-0.8,0-1.1l10.8-13.1
            c0.2-0.2,0.4-0.3,0.7-0.3h40.8c0.2,0,0.5,0.1,0.7,0.3l10.8,13.1c0.2,0.3,0.2,0.8,0,1.1l-10.8,13.1C89.3,115.3,89,115.4,88.8,115.4z
             M48.3,113.7h40l10-12.2l-10-12.2h-40l-10,12.2L48.3,113.7z"
            />
            <path
              className="st7"
              d="M63.1,126.1L63.1,126.1l-16.9-1.6c-0.4-0.1-0.7-0.4-0.8-0.8l-1.6-16.9c0-0.2,0.1-0.5,0.2-0.7l28.8-28.9
            c0.2-0.2,0.4-0.3,0.7-0.2l16.8,1.6c0.4,0.1,0.7,0.4,0.8,0.8l1.6,16.9c0,0.2-0.1,0.5-0.2,0.7l-28.8,28.9
            C63.6,126,63.4,126.1,63.1,126.1z M47.1,122.9l15.7,1.5L91.1,96l-1.5-15.7l-15.7-1.5l-28.2,28.3L47.1,122.9z"
            />
            <path
              className="st7"
              d="M73.6,126.1c-0.2,0-0.4-0.1-0.6-0.2L44.1,97c-0.2-0.2-0.3-0.4-0.2-0.7l1.6-16.9c0.1-0.4,0.4-0.7,0.8-0.8
            L63.1,77c0.2,0,0.5,0.1,0.7,0.2l28.8,28.9c0.2,0.2,0.3,0.4,0.2,0.7l-1.6,16.9c-0.1,0.4-0.4,0.7-0.8,0.8l-16.8,1.6
            C73.6,126.1,73.6,126.1,73.6,126.1z M45.6,96l28.3,28.4l15.7-1.5l1.5-15.7L62.8,78.8l-15.7,1.5L45.6,96z"
            />
          </g>
          <g id="lantern1">
            <path
              className="st7"
              d="M85.1,191.6v-0.2c-0.1,0.1-0.1,0.2-0.1,0.2H85.1z"
            />
            <path
              className="st7"
              d="M65.5,170.6c0.5-0.1,1-0.3,1.4-0.7h-0.2c-0.3,0.2-0.7,0.4-1.1,0.5c-0.1,0-0.1,0-0.2,0.1
            c-0.1,0.7-0.4,1.2-0.8,1.6c-0.1,0.1-0.1,0.1-0.2,0.2v0.1C65,172,65.4,171.4,65.5,170.6z"
            />
            <path
              className="st7"
              d="M85.1,191v-0.3c-0.1,0.4-0.2,0.7-0.5,1h0.1C84.9,191.4,85,191.2,85.1,191z"
            />
            <path
              className="st7"
              d="M84.5,175c0,0.5,0.2,0.8,0.6,0.9v-0.2c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.2-0.2-0.2-0.8,0-1.1
            c0.1-0.1,0.1-0.2,0.2-0.2v-0.2C84.7,174.2,84.5,174.5,84.5,175z"
            />
            <path
              className="st7"
              d="M84.5,188.1c0,0.5,0.2,0.8,0.6,0.9v-0.2c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.2-0.2-0.2-0.8,0-1.1
            c0.1-0.1,0.1-0.2,0.2-0.2v-0.2C84.7,187.3,84.5,187.7,84.5,188.1z"
            />
            <path
              className="st7"
              d="M65.6,182.6c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2-0.1c0.5-0.1,0.9-0.7,0.8-1.3c-0.1-0.5-0.7-0.8-1.3-0.7
            c-0.5,0.1-0.8,0.7-0.8,1.1C64.8,182.4,65,182.5,65.6,182.6z M65.1,181c0.2-0.3,0.7-0.5,1-0.4c0.1,0,0.1,0.1,0.2,0.1
            c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0.1c-0.2,0.1-0.4,0.3-0.4,0.5c0,0.2,0.1,0.2,0.3,0.3c0.2,0,0.5-0.1,0.5-0.4
            c0-0.1,0.1-0.2,0.1-0.3c0.1,0.1,0.1,0.2,0.1,0.4c0,0.4-0.2,0.7-0.5,0.8c-0.4,0.2-0.7,0.1-1-0.1l-0.1-0.1
            C64.9,181.9,64.9,181.3,65.1,181z"
            />
            <path
              className="st7"
              d="M65.8,191.6c0.4,0,0.9-0.5,1-0.9c0.1-0.6-0.4-1.2-1.1-1.2c-0.7,0.1-0.9,0.3-1,0.9c0,0.1,0,0.2,0.1,0.3
            C64.9,191.3,65.3,191.6,65.8,191.6z M65.1,190L65.1,190c0.4-0.3,0.9-0.3,1.2-0.1c0.3,0.2,0.5,0.7,0.3,1c0,0,0,0.1-0.1,0.1
            c0-0.1,0-0.2-0.1-0.2c-0.1-0.3-0.3-0.5-0.6-0.4c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.3,0.1,0.5,0.4,0.7c0.1,0,0.1,0,0.2,0.1
            c-0.2,0.2-0.4,0.2-0.6,0.1C64.9,191.2,64.8,190.6,65.1,190z"
            />
            <path
              className="st7"
              d="M65.8,178.4c0.4,0,0.9-0.5,1-0.9c0.1-0.6-0.4-1.2-1.1-1.2c-0.7,0.1-0.9,0.3-1,0.9c0,0.1,0,0.2,0.1,0.3
            C64.9,178.1,65.3,178.4,65.8,178.4z M65.1,176.8c0-0.1,0.1-0.1,0.1-0.1c0.7-0.4,1.4,0,1.4,0.7c0,0.2,0,0.3-0.1,0.5
            c0-0.1,0-0.2-0.1-0.2c-0.1-0.2-0.3-0.4-0.5-0.4c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.2,0.5,0.4,0.5c0.1,0,0.1,0,0.2,0.1
            c-0.2,0.2-0.4,0.2-0.7,0.1C65,178.1,64.8,177.4,65.1,176.8z"
            />
            <path
              className="st7"
              d="M85.1,171.8v-0.2c-0.4-0.2-0.5-0.8-0.2-1.3c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.1V170h-0.3
            c-0.2,0.1-0.4,0.5-0.4,1C84.5,171.3,84.8,171.6,85.1,171.8z"
            />
            <path
              className="st7"
              d="M84.5,184.1c0.1,0.4,0.3,0.7,0.6,0.8v-0.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.2-0.4-0.1-0.7,0.1-1l0.1-0.1
            c0.1-0.1,0.1-0.1,0.2-0.1V183C84.5,183.1,84.4,183.6,84.5,184.1z"
            />
            <path
              className="st7"
              d="M74.8,154.2c-1,0-1.6-1.9-1.6-3.9c0-1.9,0.5-3.9,1.6-3.9c1,0,1.6,1.9,1.6,3.9
            C76.3,152.2,75.8,154.2,74.8,154.2z M74.8,147.2c-0.2,0-0.8,1.1-0.8,3.1s0.6,3.1,0.8,3.1c0.2,0,0.8-1.1,0.8-3.1
            C75.6,148.2,75,147.2,74.8,147.2z"
            />
            <path
              className="st7"
              d="M76,156c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C75.5,154.8,76,155.3,76,156z"
            />
            <path
              className="st7"
              d="M75.6,154.1c0,0.4-0.4,0.7-0.7,0.7c-0.4,0-0.7-0.4-0.7-0.7c0-0.4,0.4-0.7,0.7-0.7
            C75.2,153.3,75.6,153.6,75.6,154.1z"
            />
            <path
              className="st7"
              d="M86.3,169.2c0-0.1,0-0.2,0-0.3c0-3.6-1.6-6.6-6.9-8.7c-4.1-1.7-4.6-4.4-4.6-4.4h-0.1c0,0-0.4,2.7-4.6,4.4
            c-5.3,2.1-6.9,5.1-6.9,8.7c0,0.1,0,0.2,0,0.3H86.3z"
            />
            <path
              className="st7"
              d="M63.2,192.4c0,0.1,0,0.2,0,0.3c0,3.6,1.6,6.6,6.9,8.7c4.1,1.7,4.6,4.4,4.6,4.4h0.1c0,0,0.4-2.7,4.6-4.4
            c5.3-2.1,6.9-5.1,6.9-8.7c0-0.1,0-0.2,0-0.3H63.2z"
            />
            <path
              className="st7"
              d="M86.3,192.8h-23v-24.1h23L86.3,192.8L86.3,192.8z M63.8,192.2h21.8v-22.9H63.8V192.2z"
            />
            <path
              className="st7"
              d="M85.4,191.9H64.1v-22.2h21.2L85.4,191.9L85.4,191.9z M64.7,191.3h20.1v-21.1H64.7V191.3z"
            />
            <path
              className="st7"
              d="M74.2,170c0,0.1,0.1,0.1,0.1,0.2C74.2,170.2,74.2,170.1,74.2,170h-0.2c0.2,0.2,0.2,0.5,0.3,0.8
            c0.1,0.3,0,0.5-0.2,0.7c-0.2,0.4-0.6,0.8-1.1,1.1c-0.3,0.2-0.6,0.2-1,0.1c-1-0.2-1.7-1.1-1.9-2.1c0-0.1,0-0.1-0.1-0.2
            c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.1-0.7-0.2-1-0.5h-0.2c0.4,0.3,0.8,0.5,1.4,0.7c0.1,1,0.7,1.7,1.5,2.2c-0.5-0.1-0.8-0.4-1.1-0.8
            c-0.3-0.4-0.4-0.8-0.5-1.3c-0.7-0.1-1.2-0.3-1.6-0.7h-0.5c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.3,0.3,0.4,0.4
            c0.2,0.1,0.4,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.9,0.4,1.1,1.2,1.9c-0.7,0.4-1.1,1-1.2,1.9c-0.8,0.1-1.4,0.5-1.9,1.3
            c-0.4-0.7-1.1-1.1-1.9-1.3c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.5,1.1-1.1,1.3-1.9c0.7-0.1,1.3-0.5,1.7-1h-0.5c-0.4,0.4-0.9,0.7-1.6,0.7
            c-0.1,0.9-0.5,1.5-1.2,1.9v0.6c0.7,0.4,1.1,1,1.2,1.9c1,0.1,1.7,0.6,2,1.6c-0.5-0.8-1.1-1.4-2.2-1.5c-0.1-0.8-0.5-1.4-1.1-1.9v0.1
            c0.5,0.4,0.8,0.9,1,1.6c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2,0.1,0.4,0.1c0.9,0.2,1.5,0.8,1.8,1.6c0.2,0.6,0.1,1.1-0.4,1.6
            c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4,0.3-0.8,0.4-1.3,0.2c-0.4-0.1-0.7-0.4-1-0.6v0.1c0.2,0.2,0.4,0.4,0.7,0.5
            c-0.2-0.1-0.5-0.2-0.7-0.3v0.8c0.2-0.1,0.4-0.2,0.6-0.2c-0.2,0.1-0.4,0.3-0.6,0.4v0.1c0.2-0.2,0.5-0.4,0.9-0.5
            c0.6-0.2,1.1-0.1,1.6,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.5,0.6,1,0.4,1.6c-0.4,0.9-1,1.4-1.9,1.7c-0.1,0-0.1,0-0.2,0.1
            c0,0,0,0-0.1,0c0,0.1,0,0.2-0.1,0.2c-0.2,0.7-0.5,1.2-1,1.6v0.1c0.6-0.5,1-1.1,1.1-1.9c1-0.2,1.7-0.7,2.2-1.5c-0.3,1-1,1.5-2,1.6
            c-0.1,0.8-0.5,1.5-1.2,1.9v0.6c0.7,0.4,1.1,1,1.2,1.9c0.7,0.1,1.2,0.3,1.6,0.8c0.2,0.2,0.4,0.5,0.4,0.8c-0.5-0.8-1.1-1.4-2.2-1.5
            c-0.1-0.5-0.2-0.9-0.5-1.3c-0.2-0.2-0.4-0.4-0.5-0.5v0.1c0.5,0.4,0.8,0.9,1,1.6c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0.1
            c1,0.1,1.8,0.9,2,1.9c0.1,0.4,0.1,0.8-0.2,1.2c0,0.1-0.1,0.1-0.1,0.1h0.9l-0.1-0.1c-0.3-0.4-0.4-0.8-0.2-1.3c0.4-1,1-1.6,2-1.7
            c0.1,0,0.1,0,0.2,0c0.1-0.7,0.4-1.2,0.8-1.6c0.4-0.4,0.8-0.5,1.3-0.7c0.2-0.1,0.5,0,0.7,0.1c0.5,0.3,0.9,0.7,1.2,1.2
            c0.2,0.3,0.2,0.6,0.1,0.9c-0.2,1-1.1,1.7-2.1,1.9c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1-0.1,0.2c-0.1,0.5-0.2,0.9-0.5,1.2h0.1
            c0.2-0.4,0.4-0.8,0.5-1.3c1-0.1,1.6-0.7,2.1-1.5c-0.1,0.5-0.4,0.8-0.8,1.1c-0.4,0.3-0.8,0.4-1.3,0.5c-0.1,0.5-0.2,0.8-0.4,1.2H72
            c0.1-0.2,0.2-0.5,0.3-0.8c0.8-0.1,1.4-0.5,1.9-1.3c0.4,0.7,1.1,1.1,1.9,1.3c0.1,0.3,0.2,0.6,0.3,0.9h0.4c-0.2-0.4-0.4-0.7-0.4-1.2
            c-1-0.1-1.7-0.6-2-1.6c0.5,0.8,1.1,1.4,2.2,1.5c0.1,0.5,0.2,0.9,0.5,1.3h0.1c-0.2-0.3-0.4-0.7-0.5-1.1c0-0.1-0.1-0.2-0.1-0.2
            c-0.1,0-0.1,0-0.2-0.1c-1-0.2-1.7-0.8-2-1.8c-0.2-0.5,0-1,0.4-1.4c0.1-0.1,0.2-0.2,0.4-0.4c0.1-0.1,0.1-0.1,0.2-0.1
            c0.4-0.3,0.8-0.4,1.3-0.2c1,0.4,1.6,1,1.7,2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0.1c1,0.2,1.7,0.8,2,1.8c0.2,0.5,0,1-0.3,1.3
            h0.9c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.2-0.7-0.1-1c0.2-1,1.1-1.7,2.1-1.9c0.1,0,0.1,0,0.1,0c0.1-0.5,0.2-0.9,0.5-1.3
            c0.3-0.4,0.7-0.7,1.2-0.9v-0.3c-0.9-0.3-1.6-1.1-1.7-2c0-0.1,0-0.1,0-0.2c-0.1,0-0.2-0.1-0.2-0.1c-1-0.2-1.9-1-2-2.1
            c-0.1-0.2,0-0.5,0.1-0.7c0.2-0.5,0.7-0.8,1.1-1.1c0.3-0.2,0.6-0.2,0.9-0.1c0.9,0.2,1.7,1,1.9,1.9v-0.3c-0.2-0.7-0.7-1.1-1.3-1.5
            c0.7,0.2,1.1,0.6,1.3,1.1v-0.7c-0.2-0.2-0.4-0.4-0.7-0.6c0.3-0.2,0.5-0.4,0.7-0.6v-0.7c-0.1,0.2-0.3,0.5-0.5,0.7
            c-0.2,0.2-0.5,0.4-0.8,0.4c0.6-0.4,1.1-0.8,1.3-1.5v-0.3c-0.3,1-1,1.7-2,1.9c-0.3,0.1-0.5,0-0.8-0.2c-0.4-0.2-0.8-0.6-1.1-1.1
            c-0.2-0.3-0.2-0.7-0.1-1c0.2-1,1.1-1.7,2.1-1.9c0.1,0,0.1,0,0.1,0c0-0.1,0-0.1,0.1-0.1c0.1-1,0.8-1.7,1.7-2V173
            c-0.8-0.3-1.6-1.1-1.7-2c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.1-0.7-0.2-1-0.5h-0.2c0.1,0.1,0.1,0.1,0.1,0.1
            c0.4,0.3,0.8,0.5,1.3,0.5c0.1,1,0.7,1.7,1.5,2.2c-1-0.3-1.5-1-1.6-2c-0.7-0.1-1.2-0.3-1.6-0.7l0,0c0.4,0.6,1,0.9,1.7,1
            c0.1,0.8,0.5,1.4,1.3,1.9c-0.7,0.4-1.1,1.1-1.3,1.9c-0.8,0.1-1.4,0.5-1.9,1.3c-0.4-0.7-1.1-1.1-1.9-1.3c-0.4-1.1-0.4-1.1-1.3-1.9
            c0.7-0.4,1.1-1,1.2-1.9c0.7-0.1,1.3-0.5,1.7-1h-0.5c-0.1,0.1-0.2,0.2-0.2,0.2c-0.4,0.3-0.8,0.4-1.3,0.5c-0.1,0.7-0.3,1.2-0.8,1.7
            c-0.2,0.2-0.5,0.4-0.8,0.4c0.4-0.2,0.7-0.5,1-0.8c0.3-0.4,0.4-0.8,0.5-1.3c0.5-0.1,0.9-0.2,1.3-0.5c0.1-0.1,0.1-0.1,0.2-0.1h-0.2
            c-0.3,0.2-0.7,0.4-1.1,0.5c-0.1,0-0.2,0-0.2,0.1c0,0.1,0,0.2-0.1,0.2c-0.2,1-0.8,1.7-1.9,2c-0.5,0.2-1-0.1-1.4-0.4
            c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.5-0.6-1-0.4-1.6c0.1-0.2,0.1-0.3,0.2-0.4h-0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0-0.1,0-0.1,0-0.2h-0.4
            V170z M83.1,175.1c0.1-0.7,0.3-1.2,0.8-1.7c0.3-0.2,0.5-0.4,0.8-0.4c-0.8,0.5-1.4,1.1-1.5,2.1c-1,0.1-1.6,0.7-2.1,1.5
            C81.1,176,82,175.3,83.1,175.1z M68.8,175.6c0.4-0.3,0.8-0.4,1.3-0.5c0.1-0.7,0.3-1.3,0.8-1.7c0.3-0.2,0.5-0.3,0.8-0.4
            c-0.8,0.5-1.4,1.1-1.5,2.1c-1,0.1-1.6,0.7-2.1,1.5C68,176.3,68.3,175.9,68.8,175.6z M68,177.1c0.2-1,1.1-1.7,2.1-1.9
            c0.1,0,0.1,0,0.2,0c0-0.1,0.1-0.2,0.1-0.3c0.2-1,1.1-1.8,2.1-2c0.2-0.1,0.5,0,0.7,0.1c0.5,0.2,0.8,0.7,1.1,1.1
            c0.2,0.3,0.2,0.7,0.1,1c-0.2,1-1.1,1.7-2.1,1.9c-0.1,0-0.1,0-0.1,0c0,0.1-0.1,0.1-0.1,0.1c-0.2,1.1-1,2-2.1,2.2
            c-0.2,0.1-0.5,0-0.7-0.1c-0.5-0.2-0.8-0.7-1.1-1.1C67.9,177.8,67.9,177.5,68,177.1z M74.7,176.8c0.1,0.1,0.3,0.3,0.4,0.4
            c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0.1,0.4,0.1,0.5,0.2c0.1,0.4,0.2,0.7,0.4,1.1c0.2,0.3,0.5,0.6,0.9,0.8c-0.7,0.4-1.1,1.1-1.3,1.9
            c-1,0.2-1.1,0.3-1.9,1.3c-0.4-0.7-1.1-1.1-1.9-1.2c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.4,1.1-1.1,1.3-1.9c0.8-0.1,1.4-0.5,1.9-1.3
            C74.5,176.5,74.6,176.6,74.7,176.8z M74.5,175.6c0.5,0.8,1.1,1.4,2.2,1.5c0.2,1,0.7,1.7,1.6,2.2c-0.5-0.1-0.8-0.4-1.2-0.7
            c-0.3-0.4-0.5-0.8-0.5-1.3c-0.7-0.1-1.2-0.3-1.7-0.8C74.7,176.2,74.6,176,74.5,175.6z M78.2,179.7c-0.8,0.5-1.4,1.1-1.6,2.2
            c-1,0.2-1.7,0.7-2.2,1.6c0.1-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.3c0.1-0.6,0.2-1.1,0.7-1.5
            C77.5,179.9,77.8,179.7,78.2,179.7z M74.3,183.3c-0.5-0.9-1.2-1.4-2.2-1.6c-0.2-1-0.7-1.7-1.5-2.2c0.5,0.1,0.8,0.4,1.1,0.8
            c0.3,0.4,0.4,0.8,0.5,1.3C73.3,181.8,73.9,182.3,74.3,183.3z M70.6,179.3c1-0.8,1.2-1,1.4-2.1c1-0.1,1.6-0.7,2.1-1.5
            c-0.1,0.5-0.4,0.8-0.8,1.1c-0.4,0.3-0.8,0.4-1.3,0.5C72.1,178.3,71.6,179,70.6,179.3z M66.9,179.5c0.3-0.3,0.6-0.6,0.9-0.9
            c0.3,0.3,0.6,0.7,0.9,1c-0.3,0.3-0.6,0.6-0.9,1C67.5,180.1,67.2,179.8,66.9,179.5z M67.8,189.2c-0.4-0.7-1.1-1.1-1.9-1.3
            c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.4,1.1-1.1,1.3-1.9c0.8-0.1,1.4-0.5,1.9-1.3c0.4,0.7,1.1,1.1,1.9,1.3c0.1,0.8,0.5,1.4,1.3,1.9
            c-0.7,0.4-1.1,1-1.3,1.9C68.9,188,68.3,188.4,67.8,189.2z M70.1,188.3c-1,0.1-1.6,0.7-2.1,1.5c0-0.7,0.9-1.4,2-1.6
            c0.1-0.7,0.3-1.2,0.8-1.7c0.2-0.2,0.4-0.3,0.7-0.4C70.8,186.7,70.3,187.4,70.1,188.3z M70.5,185.1c-0.3-0.4-0.4-0.8-0.5-1.3
            c-1.1-0.1-1.7-0.7-2-1.7c0.2,0.4,0.5,0.8,0.9,1.1c0.4,0.3,0.8,0.5,1.3,0.5c0.1,1,0.7,1.7,1.5,2.2C71.2,185.8,70.8,185.6,70.5,185.1
            z M72.1,186c-1-0.2-1.8-1.1-1.9-2.1c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.3-0.1-0.4-0.1c-1-0.2-1.7-1.1-1.9-2c-0.1-0.2,0-0.5,0.1-0.7
            c0.3-0.5,0.7-0.9,1.1-1.1c0.3-0.2,0.5-0.2,0.8-0.1c1,0.2,1.8,1.1,1.9,2.1c0,0.1,0,0.1,0,0.1c0.1,0,0.2,0.1,0.2,0.1
            c1,0.2,1.9,1,2,2.1c0.1,0.2,0,0.5-0.1,0.7c-0.2,0.5-0.7,0.8-1.1,1.1C72.8,186,72.5,186,72.1,186z M74.4,186.9
            c-0.3-0.3-0.6-0.6-0.9-0.9c0.3-0.3,0.6-0.6,0.9-0.9c0.3,0.3,0.6,0.6,0.9,0.9C75,186.3,74.7,186.6,74.4,186.9z M76.7,185.9
            c-0.6,0.2-1.1,0-1.5-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.5-0.6-1-0.4-1.6c0.4-0.9,1-1.4,2-1.7c0.1,0,0.1,0,0.2-0.1
            c0-0.1,0.1-0.2,0.1-0.3c0.2-1,0.8-1.6,1.8-1.9c0.6-0.2,1,0.1,1.4,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.5,0.5,0.7,1,0.4,1.6
            c-0.4,0.9-1,1.4-1.9,1.7c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.2C78.3,185,77.7,185.6,76.7,185.9z M80.8,182.2
            c0,0.4-0.3,0.8-0.7,1.1c-0.4,0.3-0.8,0.4-1.3,0.5c-0.1,0.7-0.3,1.2-0.8,1.7c-0.3,0.2-0.5,0.4-0.8,0.4c0.9-0.5,1.4-1.1,1.6-2.2
            C79.6,183.6,80.3,183.1,80.8,182.2z M78.6,188.3c-0.2-1-0.7-1.7-1.6-2.2c0.5,0.1,0.8,0.4,1.2,0.7c0.3,0.4,0.5,0.8,0.5,1.3
            c0.7,0.1,1.2,0.3,1.7,0.8c0.2,0.2,0.4,0.5,0.4,0.8C80.3,189,79.6,188.5,78.6,188.3z M83.7,187.1c-0.2,0.4-0.4,0.8-0.5,1.3
            c-1,0.1-1.6,0.7-2.1,1.4c0.4-1,1-1.4,2-1.6c0.1-0.7,0.3-1.3,0.8-1.7c0.2-0.2,0.5-0.3,0.8-0.4C84.3,186.5,84,186.7,83.7,187.1z
             M83.3,183.7c0.1,1,0.7,1.7,1.6,2.1c-0.3,0-0.8-0.3-1.1-0.7C83.4,184.8,83.3,184.3,83.3,183.7c-1.1-0.1-1.8-0.6-2.2-1.6
            C81.6,183.1,82.2,183.6,83.3,183.7z M82.8,184.2c0.1,0.8,0.5,1.4,1.3,1.9c-0.7,0.5-1.1,1.1-1.3,1.9c-0.8,0.1-1.4,0.5-1.9,1.3
            c-0.4-0.7-1.1-1.1-1.9-1.3c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.4,1.1-1.1,1.3-1.9c0.8-0.1,1.4-0.5,1.9-1.3
            C81.4,183.6,82,184.1,82.8,184.2z M81,178.6c0.3,0.3,0.6,0.6,1,1c-0.3,0.3-0.7,0.7-1,1c-0.3-0.3-0.6-0.6-1-1
            C80.3,179.2,80.6,178.9,81,178.6z M78.7,175.1c1,0.1,1.7,0.6,2,1.6c-0.5-0.8-1.1-1.4-2.2-1.5c-0.2-1-0.7-1.7-1.6-2.2
            C78.1,173.3,78.6,174.1,78.7,175.1z M75.4,173.3c0.4-0.3,0.8-0.4,1.3-0.2c1,0.4,1.6,1,1.7,2c0,0.1,0.1,0.2,0.1,0.2
            c0.9,0.1,1.6,0.5,2,1.3c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.6,0.1,1.1-0.4,1.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.1,0.1-0.2,0.2
            c-0.4,0.3-0.8,0.4-1.3,0.2c-1-0.4-1.6-1-1.7-2c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.1,0-0.2-0.1c-1-0.2-1.7-0.8-2-1.8
            c-0.2-0.5,0-1,0.3-1.3c0.2-0.2,0.4-0.4,0.5-0.5C75.4,173.3,75.4,173.3,75.4,173.3z M75.3,172.9c-0.3,0.3-0.6,0.6-0.9,0.9
            c-0.3-0.3-0.6-0.6-0.9-0.9c0.3-0.3,0.6-0.6,0.9-0.9C74.7,172.3,75,172.6,75.3,172.9z"
            />
            <path
              className="st7"
              d="M82.5,176.5c-0.4,0.2-0.6,0.7-0.5,1.2s0.6,0.8,1.1,0.7c0.5-0.1,1-0.5,0.9-1.1c0-0.7-0.3-0.9-0.9-1
            C82.9,176.3,82.7,176.4,82.5,176.5z M83.6,176.8c0.2,0.2,0.2,0.8,0,1.1c-0.2,0.4-0.7,0.4-1,0.2c0,0,0,0-0.1-0.1
            c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.4-0.3,0.4-0.5c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.5,0.1-0.6,0.4c0,0.1,0,0.2-0.1,0.3
            c-0.2-0.2-0.2-0.4-0.1-0.6C82.3,176.7,83,176.4,83.6,176.8z"
            />
            <path
              className="st7"
              d="M83.1,191.6c0.5-0.1,1-0.5,0.9-1.1c0-0.7-0.3-0.9-0.9-1c-0.2,0-0.4,0.1-0.6,0.2c-0.4,0.2-0.6,0.8-0.5,1.2
            C82.2,191.3,82.7,191.6,83.1,191.6z M82.3,191c-0.2-0.2-0.2-0.4-0.1-0.6c0.1-0.6,0.8-1,1.4-0.6l0.1,0.1c0.2,0.2,0.2,0.7,0.1,1
            c-0.2,0.3-0.5,0.5-0.9,0.4c-0.1,0-0.2-0.1-0.2-0.1c0.1,0,0.1,0,0.2-0.1c0.3-0.1,0.5-0.4,0.4-0.7c0-0.1-0.1-0.2-0.2-0.2
            c-0.3-0.1-0.6,0.1-0.7,0.4C82.3,190.9,82.3,191,82.3,191z"
            />
            <path
              className="st7"
              d="M72.9,189c0.4-0.2,0.6-0.7,0.5-1.1c-0.1-0.5-0.6-0.8-1.1-0.7c-0.5,0.1-1,0.5-0.9,1.1c0,0.7,0.2,0.9,0.9,1
            C72.5,189.1,72.7,189.1,72.9,189z M71.5,188c0-0.5,0.5-0.8,1-0.8c0.1,0,0.2,0.1,0.4,0.1c-0.1,0-0.2,0-0.2,0.1
            c-0.3,0.1-0.5,0.4-0.4,0.7c0,0.1,0.1,0.2,0.2,0.2c0.3,0.1,0.6-0.1,0.7-0.4c0-0.1,0-0.1,0-0.2c0.1,0.1,0.1,0.2,0.1,0.3
            c0.1,0.5-0.3,1-0.8,1C71.8,188.9,71.5,188.7,71.5,188z"
            />
            <path
              className="st7"
              d="M70,191.6c0.5-0.1,1-0.5,1-1.1c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.1-0.1-0.1-0.2c-0.4-0.2-0.8-0.2-1.2-0.1
            c-0.4,0.2-0.6,0.7-0.5,1.2C69,191.3,69.5,191.6,70,191.6z M69,190.4c0.2-0.6,0.8-0.9,1.4-0.5c0,0,0.1,0,0.1,0.1
            c0.2,0.2,0.2,0.8,0,1.1c-0.2,0.4-0.7,0.4-1,0.2c0,0,0,0-0.1-0.1c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.4-0.3,0.4-0.5
            c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.5,0.1-0.6,0.4c0,0.1,0,0.2-0.1,0.3C69,190.9,68.9,190.6,69,190.4z"
            />
            <path
              className="st7"
              d="M72.3,176c0.2,0,0.4-0.1,0.6-0.1c0.4-0.2,0.6-0.8,0.5-1.2c-0.2-0.5-0.6-0.8-1.1-0.7c-0.5,0.1-1,0.5-0.9,1.1
            C71.4,175.7,71.6,175.9,72.3,176z M71.7,174.5c0.2-0.3,0.5-0.5,0.9-0.4c0.1,0,0.2,0.1,0.2,0.1c-0.1,0-0.1,0-0.2,0
            c-0.3,0.1-0.5,0.3-0.4,0.6c0,0.2,0.1,0.2,0.2,0.2c0.3,0.1,0.5-0.1,0.6-0.4c0-0.1,0-0.1,0-0.2c0.2,0.2,0.2,0.4,0.1,0.6
            c-0.1,0.6-0.8,0.9-1.4,0.5l-0.1-0.1C71.5,175.3,71.5,174.8,71.7,174.5z"
            />
            <path
              className="st7"
              d="M70,178.4c0.5-0.1,1-0.5,0.9-1.1c0-0.7-0.2-0.9-0.9-1c-0.2,0-0.5,0.1-0.7,0.2c-0.4,0.2-0.6,0.8-0.5,1.2
            C69.1,178.1,69.5,178.4,70,178.4z M69.8,176.6c0.6,0,0.8,0.2,0.8,0.8c0,0.6-0.7,1-1.1,0.8c-0.1,0-0.1-0.1-0.1-0.1
            c0.1,0,0.2,0,0.2,0c0.3-0.1,0.5-0.4,0.4-0.7c0-0.1-0.1-0.2-0.2-0.2c-0.3-0.1-0.5,0.1-0.6,0.4c0,0.1,0,0.1,0,0.2
            c-0.1-0.1-0.1-0.2-0.1-0.3C68.9,177.1,69.4,176.6,69.8,176.6z"
            />
            <path
              className="st7"
              d="M76.6,183c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0.1c-0.5,0.1-0.9,0.7-0.8,1.3c0.1,0.5,0.7,0.9,1.3,0.7
            c0.5-0.1,0.8-0.7,0.7-1.1C77.4,183.2,77.2,183.1,76.6,183z M77,184.6c-0.2,0.3-0.7,0.4-1,0.2c0,0,0,0-0.1-0.1
            c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.4-0.3,0.4-0.5c0-0.2-0.1-0.3-0.3-0.3c-0.2-0.1-0.5,0.1-0.5,0.4c0,0.1-0.1,0.1-0.1,0.2
            c-0.3-0.5,0-1.1,0.5-1.3h0.1c0.3-0.1,0.8,0.1,0.8,0.3C77.3,183.9,77.2,184.4,77,184.6z"
            />
            <path
              className="st7"
              d="M78.7,182.6c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1c0.5-0.1,0.9-0.7,0.8-1.3c-0.1-0.5-0.7-0.8-1.3-0.7
            c-0.5,0.1-0.8,0.7-0.8,1.1C78,182.4,78.1,182.5,78.7,182.6z M78.3,181c0.2-0.3,0.7-0.4,1-0.3c0,0,0.1,0.1,0.1,0.1
            c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.4,0.3-0.4,0.5c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.5-0.1,0.5-0.4c0-0.1,0.1-0.2,0.1-0.3
            c0.1,0.2,0.2,0.4,0.1,0.5c-0.1,0.7-0.8,1-1.4,0.7c-0.1,0-0.1-0.1-0.1-0.1C78,181.9,78,181.3,78.3,181z"
            />
            <path
              className="st7"
              d="M75.4,171.1c0.1,0.5,0.7,0.9,1.3,0.7c0.5-0.1,0.8-0.7,0.7-1.1c-0.1-0.4-0.1-0.5-0.3-0.7h-1.2
            C75.5,170.2,75.3,170.7,75.4,171.1z M77.1,170.3c0.2,0.3,0.2,0.8,0,1.1c-0.2,0.3-0.7,0.4-1,0.3c-0.1,0-0.1-0.1-0.1-0.1
            c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.3,0.4-0.5c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.5,0.1-0.5,0.4c0,0.1-0.1,0.1-0.1,0.2
            c-0.1-0.2-0.2-0.4-0.1-0.7C75.7,170,76.5,169.8,77.1,170.3L77.1,170.3z"
            />
            <path
              className="st7"
              d="M76.5,176c0.7-0.1,0.9-0.3,1-0.9c0-0.1,0-0.2-0.1-0.3c-0.1-0.5-0.5-0.8-1.1-0.8c-0.4,0-0.9,0.5-1,0.9
            C75.3,175.4,75.8,176,76.5,176z M75.6,174.5C75.6,174.5,75.6,174.5,75.6,174.5c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.5,0.4
            c0.2,0,0.4-0.1,0.4-0.4c0-0.2-0.2-0.4-0.4-0.5c-0.1,0-0.1,0-0.2,0c0.2-0.2,0.4-0.2,0.6-0.1c0.7,0.2,0.8,0.9,0.5,1.4l-0.1,0.1
            c-0.3,0.2-0.8,0.2-1.1,0C75.6,175.4,75.4,174.9,75.6,174.5z"
            />
            <path
              className="st7"
              d="M78.9,178.4c0.4,0,0.8-0.4,1-0.8c0.1-0.6-0.3-1.3-1-1.3c-0.8-0.1-1,0.2-1.1,0.9
            C77.8,177.9,78.3,178.4,78.9,178.4z M78.9,176.6c0.7,0,1.1,0.7,0.7,1.3c0-0.1,0-0.2-0.1-0.2c-0.1-0.2-0.3-0.4-0.5-0.4
            c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.2,0.5,0.4,0.5c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.2,0.1-0.3,0.1c-0.5,0.1-1-0.4-1-0.9
            C78.1,176.8,78.3,176.6,78.9,176.6z"
            />
            <path
              className="st7"
              d="M79,191.6c0.4,0,0.9-0.5,1-0.9c0.1-0.6-0.4-1.1-1.1-1.1c-0.7,0.1-0.9,0.3-1,1c0,0.1,0,0.2,0.1,0.3
            C78,191.3,78.4,191.6,79,191.6z M78.2,190c0-0.1,0.1-0.1,0.1-0.1c0.7-0.4,1.4,0,1.4,0.7c0,0.2,0,0.3-0.1,0.5c0-0.1-0.1-0.2-0.1-0.2
            c-0.1-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.2,0.1-0.3,0.2c-0.1,0.2,0.1,0.5,0.4,0.6c0.1,0,0.1,0,0.2,0.1c-0.2,0.2-0.4,0.2-0.7,0.1
            C78.1,191.2,77.9,190.6,78.2,190z"
            />
            <path
              className="st7"
              d="M76.3,187.1c-0.4,0-0.9,0.5-1,0.9c-0.1,0.6,0.4,1.1,1.1,1.1c0.7-0.1,0.9-0.3,1-1c0-0.1,0-0.2-0.1-0.3
            C77.3,187.4,76.8,187.1,76.3,187.1z M77.1,188.7L77.1,188.7c-0.4,0.3-0.9,0.3-1.2,0.1c-0.3-0.2-0.5-0.7-0.3-1c0,0,0-0.1,0.1-0.1
            c0,0.1,0,0.2,0.1,0.2c0.1,0.2,0.2,0.4,0.5,0.4c0.2,0,0.4-0.1,0.4-0.4s-0.2-0.5-0.4-0.5c-0.1,0-0.1,0-0.2,0c0.2-0.2,0.4-0.2,0.6-0.1
            C77.2,187.4,77.4,188.1,77.1,188.7z"
            />
            <path
              className="st7"
              d="M71.3,170.8c0,0.4,0.2,0.7,0.6,1c0.4,0.2,0.7,0.2,1-0.1c0.4-0.2,0.5-0.5,0.5-1c-0.1-0.3-0.2-0.6-0.5-0.7h-1.2
            C71.4,170.1,71.4,170.4,71.3,170.8z M71.8,170.2c0.3-0.2,0.7-0.2,1-0.1c0.3,0.2,0.5,0.5,0.5,0.8c0,0.1-0.1,0.2-0.1,0.4
            c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.3-0.4-0.5-0.4c-0.2,0-0.2,0.1-0.3,0.3c0,0.2,0.1,0.5,0.4,0.5c0.1,0,0.2,0.1,0.3,0.1
            c-0.2,0.1-0.4,0.2-0.6,0.1C71.8,171.6,71.4,171,71.8,170.2C71.7,170.3,71.7,170.2,71.8,170.2z"
            />
            <path
              className="st7"
              d="M72.2,183c-0.6,0.1-0.8,0.2-0.9,1c0,0.4,0.1,0.7,0.5,0.9c0.4,0.2,0.7,0.2,1,0.1c0.4-0.2,0.6-0.5,0.5-1
            C73.3,183.3,72.7,182.9,72.2,183z M73.1,184.5c0-0.1,0-0.2-0.1-0.2c-0.1-0.3-0.4-0.4-0.6-0.4c-0.2,0-0.2,0.1-0.2,0.2
            c-0.1,0.3,0.1,0.5,0.4,0.6c0.1,0,0.1,0,0.2,0.1c-0.2,0.2-0.5,0.2-0.7,0.1c-0.5-0.2-0.8-0.8-0.4-1.4c0-0.1,0.1-0.1,0.1-0.1
            c0.3-0.2,0.7-0.2,1-0.1c0.3,0.2,0.5,0.5,0.5,0.8C73.2,184.2,73.2,184.4,73.1,184.5z"
            />
            <path
              className="st7"
              d="M70.3,180.6c-0.3-0.2-0.7-0.2-1,0c-0.4,0.2-0.5,0.5-0.5,1c0.1,0.5,0.5,0.9,1,0.9c0.7,0,1-0.2,1.1-1
            C70.9,181.2,70.8,180.9,70.3,180.6z M70.6,182.1c0,0.1-0.1,0.1-0.1,0.1c-0.2,0.2-0.7,0.2-1,0.1c-0.3-0.2-0.5-0.5-0.4-0.9
            c0-0.1,0.1-0.2,0.1-0.2c0,0.1,0,0.1,0,0.1s0,0.1,0.1,0.2c0.1,0.2,0.4,0.4,0.6,0.3c0.2-0.1,0.2-0.1,0.2-0.3c0-0.2-0.1-0.5-0.3-0.5
            c-0.1-0.1-0.2-0.1-0.3-0.1c0.5-0.3,1.2,0.1,1.3,0.7C70.7,181.7,70.7,181.9,70.6,182.1z"
            />
            <path
              className="st7"
              d="M82.7,180.6c-0.4,0.1-0.7,0.6-0.7,1.1c0.1,0.5,0.4,0.9,1,0.9c0.8,0.1,1.1-0.2,1.1-1c-0.1-0.2-0.1-0.4-0.2-0.5
            C83.7,180.6,83.1,180.4,82.7,180.6z M83.7,182.1L83.7,182.1c-0.3,0.2-0.8,0.3-1.1,0.1s-0.5-0.5-0.4-0.8c0-0.1,0.1-0.2,0.1-0.3h0.1
            c0,0.1,0,0.1,0,0.1s0,0.1,0,0.1c0.1,0.2,0.3,0.4,0.5,0.4c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.5-0.4-0.6c-0.1,0-0.2-0.1-0.3-0.1
            c0.1-0.1,0.3-0.1,0.4-0.1c0.4,0,0.6,0.2,0.8,0.5C83.9,181.5,83.9,181.8,83.7,182.1z"
            />
            <path className="st7" d="M70.2,169.4h-0.5v24.8h0.5V169.4z" />
            <path className="st7" d="M80.1,169.4h-0.5v24.8h0.5V169.4z" />
            <path className="st7" d="M75,44.3h-0.5v102.8H75V44.3z" />
          </g>
          <g id="lantern2">
            <path
              className="st8"
              d="M100,107.1c-1,0-1.6-1.9-1.6-3.9s0.5-3.9,1.6-3.9c1,0,1.6,1.9,1.6,3.9S101,107.1,100,107.1z M100,100.1
            c-0.2,0-0.8,1.1-0.8,3.1c0,2,0.6,3.1,0.8,3.1c0.2,0,0.8-1.1,0.8-3.1C100.8,101.1,100.2,100.1,100,100.1z"
            />
            <path
              className="st8"
              d="M101.2,108.9c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2
            C100.6,107.7,101.2,108.2,101.2,108.9z"
            />
            <path
              className="st8"
              d="M100.7,107c0,0.4-0.4,0.7-0.7,0.7c-0.4,0-0.7-0.4-0.7-0.7c0-0.4,0.4-0.7,0.7-0.7
            C100.4,106.2,100.7,106.5,100.7,107z"
            />
            <path
              className="st8"
              d="M111.4,122.1c0-0.1,0-0.2,0-0.3c0-3.6-1.6-6.6-6.9-8.7c-4.1-1.7-4.6-4.4-4.6-4.4h-0.1c0,0-0.4,2.7-4.6,4.4
            c-5.3,2.1-6.9,5.1-6.9,8.7c0,0.1,0,0.2,0,0.3H111.4z"
            />
            <path
              className="st8"
              d="M88.4,145.3c0,0.1,0,0.2,0,0.3c0,3.6,1.6,6.6,6.9,8.7c4.1,1.7,4.6,4.4,4.6,4.4h0.1c0,0,0.4-2.7,4.6-4.4
            c5.3-2.1,6.9-5.1,6.9-8.7c0-0.1,0-0.2,0-0.3H88.4z"
            />
            <path
              className="st8"
              d="M111.4,145.7h-23v-24.1h23V145.7L111.4,145.7z M89,145.1h21.8v-22.9H89V145.1z"
            />
            <path
              className="st8"
              d="M110.5,144.8H89.3v-22.2h21.2V144.8L110.5,144.8z M89.9,144.2h20.1v-21.1H89.9V144.2z"
            />
            <path
              className="st8"
              d="M110.2,144.5v-0.2c-0.1,0.1-0.1,0.2-0.1,0.2H110.2z"
            />
            <path
              className="st8"
              d="M90.7,123.5c0.5-0.1,1-0.3,1.4-0.7H92c-0.3,0.2-0.7,0.4-1.1,0.5c-0.1,0-0.1,0-0.2,0.1
            c-0.1,0.7-0.4,1.2-0.8,1.6c-0.1,0.1-0.1,0.1-0.2,0.2v0.1C90.2,124.9,90.6,124.3,90.7,123.5z"
            />
            <path
              className="st8"
              d="M110.2,143.9v-0.3c-0.1,0.4-0.2,0.7-0.5,1h0.1C110,144.3,110.1,144.1,110.2,143.9z"
            />
            <path
              className="st8"
              d="M99.4,122.9c0,0.1,0.1,0.1,0.1,0.2C99.4,123.1,99.4,123,99.4,122.9h-0.2c0.2,0.2,0.2,0.5,0.3,0.8
            c0.1,0.3,0,0.5-0.2,0.7c-0.2,0.4-0.6,0.8-1.1,1.1c-0.3,0.2-0.6,0.2-1,0.1c-1-0.2-1.7-1.1-1.9-2.1c0-0.1,0-0.1-0.1-0.2
            c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.1-0.7-0.2-1-0.5h-0.2c0.4,0.3,0.8,0.5,1.4,0.7c0.1,1,0.7,1.7,1.5,2.2c-0.5-0.1-0.8-0.4-1.1-0.8
            c-0.3-0.4-0.4-0.8-0.5-1.3c-0.7-0.1-1.2-0.3-1.6-0.7H93c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.1,0.4,0.2,0.5,0.3
            c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.9,0.4,1.1,1.2,1.9c-0.7,0.4-1.1,1-1.2,1.9c-0.8,0.1-1.4,0.5-1.9,1.3c-0.4-0.7-1.1-1.1-1.9-1.3
            c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.5,1.1-1.1,1.3-1.9c0.7-0.1,1.3-0.5,1.7-1h-0.5c-0.4,0.4-0.9,0.7-1.6,0.7c-0.1,0.9-0.5,1.5-1.2,1.9
            v0.6c0.7,0.4,1.1,1,1.2,1.9c1,0.1,1.7,0.6,2,1.6c-0.5-0.8-1.1-1.4-2.2-1.5c-0.1-0.8-0.5-1.4-1.1-1.9v0.1c0.5,0.4,0.8,0.9,1,1.6
            c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2,0.1,0.4,0.1c0.9,0.2,1.5,0.8,1.8,1.6c0.2,0.6,0.1,1.1-0.4,1.6c-0.1,0.1-0.2,0.2-0.4,0.4
            c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4,0.3-0.8,0.4-1.3,0.2c-0.4-0.1-0.7-0.4-1-0.6v0.1c0.2,0.2,0.4,0.4,0.7,0.5c-0.2-0.1-0.5-0.2-0.7-0.3
            v0.8c0.2-0.1,0.4-0.2,0.6-0.2c-0.2,0.1-0.4,0.3-0.6,0.4v0.1c0.2-0.2,0.5-0.4,0.9-0.5c0.6-0.2,1.1-0.1,1.6,0.4
            c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.5,0.6,1,0.4,1.6c-0.4,0.9-1,1.4-1.9,1.7c-0.1,0-0.1,0-0.2,0.1c0,0,0,0-0.1,0c0,0.1,0,0.2-0.1,0.2
            c-0.2,0.7-0.5,1.2-1,1.6v0.1c0.6-0.5,1-1.1,1.1-1.9c1-0.2,1.7-0.7,2.2-1.5c-0.3,1-1,1.5-2,1.6c-0.1,0.8-0.5,1.5-1.2,1.9v0.6
            c0.7,0.4,1.1,1,1.2,1.9c0.7,0.1,1.2,0.3,1.6,0.8c0.2,0.2,0.4,0.5,0.4,0.8c-0.5-0.8-1.1-1.4-2.2-1.5c-0.1-0.5-0.2-0.9-0.5-1.3
            c-0.2-0.2-0.4-0.4-0.5-0.5v0.1c0.5,0.4,0.8,0.9,1,1.6c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0.1c1,0.1,1.8,0.9,2,1.9
            c0.1,0.4,0.1,0.8-0.2,1.2c0,0.1-0.1,0.1-0.1,0.1h0.9l-0.1-0.1c-0.3-0.4-0.4-0.8-0.2-1.3c0.4-1,1-1.6,2-1.7c0.1,0,0.1,0,0.2,0
            c0.1-0.7,0.4-1.2,0.8-1.6c0.4-0.4,0.8-0.5,1.3-0.7c0.2-0.1,0.5,0,0.7,0.1c0.5,0.3,0.9,0.7,1.2,1.2c0.2,0.3,0.2,0.6,0.1,0.9
            c-0.2,1-1.1,1.7-2.1,1.9c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1-0.1,0.2c-0.1,0.5-0.2,0.9-0.5,1.2h0.1c0.2-0.4,0.4-0.8,0.5-1.3
            c1-0.1,1.6-0.7,2.1-1.5c-0.1,0.5-0.4,0.8-0.8,1.1c-0.4,0.3-0.8,0.4-1.3,0.5c-0.1,0.5-0.2,0.8-0.4,1.2h0.4c0.1-0.2,0.2-0.5,0.3-0.8
            c0.8-0.1,1.4-0.5,1.9-1.3c0.4,0.7,1.1,1.1,1.9,1.3c0.1,0.3,0.2,0.6,0.3,0.9h0.4c-0.2-0.4-0.4-0.7-0.4-1.2c-1-0.1-1.7-0.6-2-1.6
            c0.5,0.8,1.1,1.4,2.2,1.5c0.1,0.5,0.2,0.9,0.5,1.3h0.1c-0.2-0.3-0.4-0.7-0.5-1.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.1,0-0.2-0.1
            c-1-0.2-1.7-0.8-2-1.8c-0.2-0.5,0-1,0.4-1.4c0.1-0.1,0.2-0.2,0.4-0.4c0.1-0.1,0.1-0.1,0.2-0.1c0.4-0.3,0.8-0.4,1.3-0.2
            c1,0.4,1.6,1,1.7,2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0.1c1,0.2,1.7,0.8,2,1.8c0.2,0.5,0,1-0.3,1.3h0.9
            c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.2-0.7-0.1-1c0.2-1,1.1-1.7,2.1-1.9c0.1,0,0.1,0,0.1,0c0.1-0.5,0.2-0.9,0.5-1.3
            c0.3-0.4,0.7-0.7,1.2-0.9v-0.3c-0.9-0.3-1.6-1.1-1.7-2c0-0.1,0-0.1,0-0.2c-0.1,0-0.2-0.1-0.2-0.1c-1-0.2-1.9-1-2-2.1
            c-0.1-0.2,0-0.5,0.1-0.7c0.2-0.5,0.7-0.8,1.1-1.1c0.3-0.2,0.6-0.2,0.9-0.1c0.9,0.2,1.7,1,1.9,1.9v-0.3c-0.2-0.7-0.7-1.1-1.3-1.5
            c0.7,0.2,1.1,0.6,1.3,1.1v-0.7c-0.2-0.2-0.4-0.4-0.7-0.6c0.3-0.2,0.5-0.4,0.7-0.6v-0.7c-0.1,0.2-0.3,0.5-0.5,0.7
            c-0.2,0.2-0.5,0.4-0.8,0.4c0.6-0.4,1.1-0.8,1.3-1.5v-0.3c-0.3,1-1,1.7-2,1.9c-0.3,0.1-0.5,0-0.8-0.2c-0.4-0.2-0.8-0.6-1.1-1.1
            c-0.2-0.3-0.2-0.7-0.1-1c0.2-1,1.1-1.7,2.1-1.9c0.1,0,0.1,0,0.1,0c0-0.1,0-0.1,0.1-0.1c0.1-1,0.8-1.7,1.7-2v-0.3
            c-0.8-0.3-1.6-1.1-1.7-2c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.3-0.1-0.4-0.1c-0.4-0.1-0.7-0.2-1-0.5h-0.2c0.1,0.1,0.1,0.1,0.1,0.1
            c0.4,0.3,0.8,0.5,1.3,0.5c0.1,1,0.7,1.7,1.5,2.2c-1-0.3-1.5-1-1.6-2c-0.7-0.1-1.2-0.3-1.6-0.7h-0.5c0.4,0.6,1,0.9,1.7,1
            c0.1,0.8,0.5,1.4,1.3,1.9c-0.7,0.4-1.1,1.1-1.3,1.9c-0.8,0.1-1.4,0.5-1.9,1.3c-0.4-0.7-1.1-1.1-1.9-1.3c-0.4-1.1-0.4-1.1-1.3-1.9
            c0.7-0.4,1.1-1,1.2-1.9c0.7-0.1,1.3-0.5,1.7-1h-0.5c-0.1,0.1-0.2,0.2-0.2,0.2c-0.4,0.3-0.8,0.4-1.3,0.5c-0.1,0.7-0.3,1.2-0.8,1.7
            c-0.2,0.2-0.5,0.4-0.8,0.4c0.4-0.2,0.7-0.5,1-0.8c0.3-0.4,0.4-0.8,0.5-1.3c0.5-0.1,0.9-0.2,1.3-0.5c0.1-0.1,0.1-0.1,0.2-0.1h-0.2
            c-0.3,0.2-0.7,0.4-1.1,0.5c-0.1,0-0.2,0-0.2,0.1c0,0.1,0,0.2-0.1,0.2c-0.2,1-0.8,1.7-1.9,2c-0.5,0.2-1-0.1-1.4-0.4
            c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.5-0.6-1-0.4-1.6c0.1-0.2,0.1-0.3,0.2-0.4h-0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0-0.1,0-0.1,0-0.2h0.1
            V122.9z M108.3,128c0.1-0.7,0.3-1.2,0.8-1.7c0.3-0.2,0.5-0.4,0.8-0.4c-0.8,0.5-1.4,1.1-1.5,2.1c-1,0.1-1.6,0.7-2.1,1.5
            C106.3,128.9,107.2,128.2,108.3,128z M93.9,128.5c0.4-0.3,0.8-0.4,1.3-0.5c0.1-0.7,0.3-1.3,0.8-1.7c0.3-0.2,0.5-0.3,0.8-0.4
            c-0.8,0.5-1.4,1.1-1.5,2.1c-1,0.1-1.6,0.7-2.1,1.5C93.2,129.2,93.5,128.8,93.9,128.5z M93.1,130c0.2-1,1.1-1.7,2.1-1.9
            c0.1,0,0.1,0,0.2,0c0-0.1,0.1-0.2,0.1-0.3c0.2-1,1.1-1.8,2.1-2c0.2-0.1,0.5,0,0.7,0.1c0.5,0.2,0.8,0.7,1.1,1.1
            c0.2,0.3,0.2,0.7,0.1,1c-0.2,1-1.1,1.7-2.1,1.9c-0.1,0-0.1,0-0.1,0c0,0.1-0.1,0.1-0.1,0.1c-0.2,1.1-1,2-2.1,2.2
            c-0.2,0.1-0.5,0-0.7-0.1c-0.5-0.2-0.8-0.7-1.1-1.1C93,130.7,93,130.4,93.1,130z M99.9,129.7c0.1,0.1,0.3,0.3,0.4,0.4
            c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0.1,0.4,0.1,0.5,0.2c0.1,0.4,0.2,0.7,0.4,1.1c0.2,0.3,0.5,0.6,0.9,0.8c-0.7,0.4-1.1,1.1-1.3,1.9
            c-1,0.2-1.1,0.3-1.9,1.3c-0.4-0.7-1.1-1.1-1.9-1.2c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.4,1.1-1.1,1.3-1.9c0.8-0.1,1.4-0.5,1.9-1.3
            C99.7,129.4,99.8,129.5,99.9,129.7z M99.7,128.5c0.5,0.8,1.1,1.4,2.2,1.5c0.2,1,0.7,1.7,1.6,2.2c-0.5-0.1-0.8-0.4-1.2-0.7
            c-0.3-0.4-0.5-0.8-0.5-1.3c-0.7-0.1-1.2-0.3-1.7-0.8C99.9,129.1,99.7,128.9,99.7,128.5z M103.3,132.6c-0.8,0.5-1.4,1.1-1.6,2.2
            c-1,0.2-1.7,0.7-2.2,1.6c0.1-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.3c0.1-0.6,0.2-1.1,0.7-1.5
            C102.7,132.8,103,132.6,103.3,132.6z M99.4,136.3c-0.5-0.9-1.2-1.4-2.2-1.6c-0.2-1-0.7-1.7-1.5-2.2c0.5,0.1,0.8,0.4,1.1,0.8
            c0.3,0.4,0.4,0.8,0.5,1.3C98.4,134.7,99.1,135.2,99.4,136.3z M95.8,132.2c1-0.8,1.2-1,1.4-2.1c1-0.1,1.6-0.7,2.1-1.5
            c-0.1,0.5-0.4,0.8-0.8,1.1c-0.4,0.3-0.8,0.4-1.3,0.5C97.3,131.2,96.8,131.9,95.8,132.2z M92.1,132.4c0.3-0.3,0.6-0.6,0.9-0.9
            c0.3,0.3,0.6,0.7,0.9,1c-0.3,0.3-0.6,0.6-0.9,1C92.7,133,92.3,132.7,92.1,132.4z M93,142.1c-0.4-0.7-1.1-1.1-1.9-1.3
            c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.4,1.1-1.1,1.3-1.9c0.8-0.1,1.4-0.5,1.9-1.3c0.4,0.7,1.1,1.1,1.9,1.3c0.1,0.8,0.5,1.4,1.3,1.9
            c-0.7,0.4-1.1,1-1.3,1.9C94.1,140.9,93.4,141.4,93,142.1z M95.3,141.2c-1,0.1-1.6,0.7-2.1,1.5c0-0.7,0.9-1.4,2-1.6
            c0.1-0.7,0.3-1.2,0.8-1.7c0.2-0.2,0.4-0.3,0.7-0.4C95.9,139.6,95.5,140.3,95.3,141.2z M95.6,138c-0.3-0.4-0.4-0.8-0.5-1.3
            c-1.1-0.1-1.7-0.7-2-1.7c0.2,0.4,0.5,0.8,0.9,1.1c0.4,0.3,0.8,0.5,1.3,0.5c0.1,1,0.7,1.7,1.5,2.2C96.4,138.7,95.9,138.5,95.6,138z
             M97.3,138.9c-1-0.2-1.8-1.1-1.9-2.1c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.3-0.1-0.4-0.1c-1-0.2-1.7-1.1-1.9-2c-0.1-0.2,0-0.5,0.1-0.7
            c0.3-0.5,0.7-0.9,1.1-1.1c0.3-0.2,0.5-0.2,0.8-0.1c1,0.2,1.8,1.1,1.9,2.1c0,0.1,0,0.1,0,0.1c0.1,0,0.2,0.1,0.2,0.1
            c1,0.2,1.9,1,2,2.1c0.1,0.2,0,0.5-0.1,0.7c-0.2,0.5-0.7,0.8-1.1,1.1C98,138.9,97.7,138.9,97.3,138.9z M99.5,139.8
            c-0.3-0.3-0.6-0.6-0.9-0.9c0.3-0.3,0.6-0.6,0.9-0.9c0.3,0.3,0.6,0.6,0.9,0.9C100.1,139.2,99.8,139.5,99.5,139.8z M101.9,138.8
            c-0.6,0.2-1.1,0-1.5-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.5-0.6-1-0.4-1.6c0.4-0.9,1-1.4,2-1.7c0.1,0,0.1,0,0.2-0.1
            c0-0.1,0.1-0.2,0.1-0.3c0.2-1,0.8-1.6,1.8-1.9c0.6-0.2,1,0.1,1.4,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.5,0.5,0.7,1,0.4,1.6
            c-0.4,0.9-1,1.4-1.9,1.7c-0.1,0-0.2,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.2C103.4,137.9,102.8,138.5,101.9,138.8z M105.9,135.1
            c0,0.4-0.3,0.8-0.7,1.1c-0.4,0.3-0.8,0.4-1.3,0.5c-0.1,0.7-0.3,1.2-0.8,1.7c-0.3,0.2-0.5,0.4-0.8,0.4c0.9-0.5,1.4-1.1,1.6-2.2
            C104.8,136.5,105.5,136,105.9,135.1z M103.8,141.2c-0.2-1-0.7-1.7-1.6-2.2c0.5,0.1,0.8,0.4,1.2,0.7c0.3,0.4,0.5,0.8,0.5,1.3
            c0.7,0.1,1.2,0.3,1.7,0.8c0.2,0.2,0.4,0.5,0.4,0.8C105.5,141.9,104.8,141.4,103.8,141.2z M108.9,140c-0.2,0.4-0.4,0.8-0.5,1.3
            c-1,0.1-1.6,0.7-2.1,1.4c0.4-1,1-1.4,2-1.6c0.1-0.7,0.3-1.3,0.8-1.7c0.2-0.2,0.5-0.3,0.8-0.4C109.5,139.4,109.2,139.6,108.9,140z
             M108.4,136.6c0.1,1,0.7,1.7,1.6,2.1c-0.3,0-0.8-0.3-1.1-0.7C108.6,137.7,108.4,137.2,108.4,136.6c-1.1-0.1-1.8-0.6-2.2-1.6
            C106.7,136,107.4,136.5,108.4,136.6z M108,137.1c0.1,0.8,0.5,1.4,1.3,1.9c-0.7,0.5-1.1,1.1-1.3,1.9c-0.8,0.1-1.4,0.5-1.9,1.3
            c-0.4-0.7-1.1-1.1-1.9-1.3c-0.1-0.8-0.5-1.4-1.3-1.9c0.7-0.4,1.1-1.1,1.3-1.9c0.8-0.1,1.4-0.5,1.9-1.3
            C106.6,136.5,107.2,136.9,108,137.1z M106.1,131.5c0.3,0.3,0.6,0.6,1,1c-0.3,0.3-0.7,0.7-1,1c-0.3-0.3-0.6-0.6-1-1
            C105.4,132.1,105.8,131.8,106.1,131.5z M103.9,128c1,0.1,1.7,0.6,2,1.6c-0.5-0.8-1.1-1.4-2.2-1.5c-0.2-1-0.7-1.7-1.6-2.2
            C103.3,126.2,103.8,126.9,103.9,128z M100.6,126.2c0.4-0.3,0.8-0.4,1.3-0.2c1,0.4,1.6,1,1.7,2c0,0.1,0.1,0.2,0.1,0.2
            c0.9,0.1,1.6,0.5,2,1.3c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.6,0.1,1.1-0.4,1.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.1,0.1-0.2,0.2
            c-0.4,0.3-0.8,0.4-1.3,0.2c-1-0.4-1.6-1-1.7-2c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.1,0-0.2-0.1c-1-0.2-1.7-0.8-2-1.8
            c-0.2-0.5,0-1,0.3-1.3c0.2-0.2,0.4-0.4,0.5-0.5C100.6,126.2,100.6,126.2,100.6,126.2z M100.4,125.8c-0.3,0.3-0.6,0.6-0.9,0.9
            c-0.3-0.3-0.6-0.6-0.9-0.9c0.3-0.3,0.6-0.6,0.9-0.9C99.8,125.2,100.1,125.5,100.4,125.8z"
            />
            <path
              className="st8"
              d="M109.6,127.9c0,0.5,0.2,0.8,0.6,0.9v-0.2c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.2-0.2-0.2-0.8,0-1.1
            c0.1-0.1,0.1-0.2,0.2-0.2v-0.2C109.9,127.1,109.6,127.4,109.6,127.9z"
            />
            <path
              className="st8"
              d="M107.7,129.4c-0.4,0.2-0.6,0.7-0.5,1.2c0.1,0.5,0.6,0.8,1.1,0.7c0.5-0.1,1-0.5,0.9-1.1c0-0.7-0.3-0.9-0.9-1
            C108,129.3,107.8,129.3,107.7,129.4z M108.8,129.7c0.2,0.2,0.2,0.8,0,1.1c-0.2,0.4-0.7,0.4-1,0.2c0,0,0,0-0.1-0.1
            c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.4-0.3,0.4-0.5c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.5,0.1-0.6,0.4c0,0.1,0,0.2-0.1,0.3
            c-0.2-0.2-0.2-0.4-0.1-0.6C107.5,129.6,108.1,129.3,108.8,129.7C108.8,129.7,108.7,129.7,108.8,129.7z"
            />
            <path
              className="st8"
              d="M109.6,141c0,0.5,0.2,0.8,0.6,0.9v-0.2c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.2-0.2-0.2-0.8,0-1.1
            c0.1-0.1,0.1-0.2,0.2-0.2v-0.2C109.9,140.2,109.6,140.6,109.6,141z"
            />
            <path
              className="st8"
              d="M108.3,144.5c0.5-0.1,1-0.5,0.9-1.1c0-0.7-0.3-0.9-0.9-1c-0.2,0-0.4,0.1-0.6,0.2c-0.4,0.2-0.6,0.8-0.5,1.2
            C107.3,144.2,107.8,144.5,108.3,144.5z M107.4,143.9c-0.2-0.2-0.2-0.4-0.1-0.6c0.1-0.6,0.8-1,1.4-0.6l0.1,0.1
            c0.2,0.2,0.2,0.7,0.1,1c-0.2,0.3-0.5,0.5-0.9,0.4c-0.1,0-0.2-0.1-0.2-0.1c0.1,0,0.1,0,0.2-0.1c0.3-0.1,0.5-0.4,0.4-0.7
            c0-0.1-0.1-0.2-0.2-0.2c-0.3-0.1-0.6,0.1-0.7,0.4C107.5,143.8,107.5,143.9,107.4,143.9z"
            />
            <path
              className="st8"
              d="M98,141.9c0.4-0.2,0.6-0.7,0.5-1.1c-0.1-0.5-0.6-0.8-1.1-0.7c-0.5,0.1-1,0.5-0.9,1.1c0,0.7,0.2,0.9,0.9,1
            C97.6,142,97.9,142,98,141.9z M96.7,140.9c0-0.5,0.5-0.8,1-0.8c0.1,0,0.2,0.1,0.4,0.1c-0.1,0-0.2,0-0.2,0.1
            c-0.3,0.1-0.5,0.4-0.4,0.7c0,0.1,0.1,0.2,0.2,0.2c0.3,0.1,0.6-0.1,0.7-0.4c0-0.1,0-0.1,0-0.2c0.1,0.1,0.1,0.2,0.1,0.3
            c0.1,0.5-0.3,1-0.8,1C97,141.8,96.7,141.6,96.7,140.9z"
            />
            <path
              className="st8"
              d="M95.1,144.5c0.5-0.1,1-0.5,1-1.1c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.1-0.1-0.1-0.2c-0.4-0.2-0.8-0.2-1.2-0.1
            c-0.4,0.2-0.6,0.7-0.5,1.2C94.2,144.2,94.7,144.5,95.1,144.5z M94.2,143.3c0.2-0.6,0.8-0.9,1.4-0.5c0,0,0.1,0,0.1,0.1
            c0.2,0.2,0.2,0.8,0,1.1c-0.2,0.4-0.7,0.4-1,0.2c0,0,0,0-0.1-0.1c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.4-0.3,0.4-0.5
            c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.5,0.1-0.6,0.4c0,0.1,0,0.2-0.1,0.3C94.1,143.8,94.1,143.5,94.2,143.3z"
            />
            <path
              className="st8"
              d="M97.4,128.9c0.2,0,0.4-0.1,0.6-0.1c0.4-0.2,0.6-0.8,0.5-1.2c-0.2-0.5-0.6-0.8-1.1-0.7c-0.5,0.1-1,0.5-0.9,1.1
            C96.5,128.6,96.8,128.8,97.4,128.9z M96.8,127.4c0.2-0.3,0.5-0.5,0.9-0.4c0.1,0,0.2,0.1,0.2,0.1c-0.1,0-0.1,0-0.2,0
            c-0.3,0.1-0.5,0.3-0.4,0.6c0,0.2,0.1,0.2,0.2,0.2c0.3,0.1,0.5-0.1,0.6-0.4c0-0.1,0-0.1,0-0.2c0.2,0.2,0.2,0.4,0.1,0.6
            c-0.1,0.6-0.8,0.9-1.4,0.5l-0.1-0.1C96.7,128.2,96.7,127.7,96.8,127.4z"
            />
            <path
              className="st8"
              d="M95.1,131.3c0.5-0.1,1-0.5,0.9-1.1c0-0.7-0.2-0.9-0.9-1c-0.2,0-0.5,0.1-0.7,0.2c-0.4,0.2-0.6,0.8-0.5,1.2
            C94.2,131.1,94.7,131.4,95.1,131.3z M95,129.5c0.6,0,0.8,0.2,0.8,0.8c0,0.6-0.7,1-1.1,0.8c-0.1,0-0.1-0.1-0.1-0.1
            c0.1,0,0.2,0,0.2,0c0.3-0.1,0.5-0.4,0.4-0.7c0-0.1-0.1-0.2-0.2-0.2c-0.3-0.1-0.5,0.1-0.6,0.4c0,0.1,0,0.1,0,0.2
            c-0.1-0.1-0.1-0.2-0.1-0.3C94.1,130,94.5,129.5,95,129.5z"
            />
            <path
              className="st8"
              d="M101.7,135.9c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0.1c-0.5,0.1-0.9,0.7-0.8,1.3c0.1,0.5,0.7,0.9,1.3,0.7
            c0.5-0.1,0.8-0.7,0.7-1.1C102.5,136.1,102.4,136,101.7,135.9z M102.2,137.5c-0.2,0.3-0.7,0.4-1,0.2c0,0,0,0-0.1-0.1
            c0.1,0,0.2-0.1,0.2-0.1c0.2-0.1,0.4-0.3,0.4-0.5c0-0.2-0.1-0.3-0.3-0.3c-0.2-0.1-0.5,0.1-0.5,0.4c0,0.1-0.1,0.1-0.1,0.2
            c-0.3-0.5,0-1.1,0.5-1.3h0.1c0.3-0.1,0.8,0.1,0.8,0.3C102.5,136.8,102.4,137.2,102.2,137.5z"
            />
            <path
              className="st8"
              d="M103.9,135.5c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1c0.5-0.1,0.9-0.7,0.8-1.3c-0.1-0.5-0.7-0.8-1.3-0.7
            c-0.5,0.1-0.8,0.7-0.8,1.1C103.1,135.3,103.3,135.4,103.9,135.5z M103.4,133.9c0.2-0.3,0.7-0.4,1-0.3c0,0,0.1,0.1,0.1,0.1
            c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.4,0.3-0.4,0.5c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.5-0.1,0.5-0.4c0-0.1,0.1-0.2,0.1-0.3
            c0.1,0.2,0.2,0.4,0.1,0.5c-0.1,0.7-0.8,1-1.4,0.7c-0.1,0-0.1-0.1-0.1-0.1C103.1,134.8,103.2,134.2,103.4,133.9z"
            />
            <path
              className="st8"
              d="M90.8,135.5c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2-0.1c0.5-0.1,0.9-0.7,0.8-1.3c-0.1-0.5-0.7-0.8-1.3-0.7
            c-0.5,0.1-0.8,0.7-0.8,1.1C90,135.3,90.2,135.4,90.8,135.5z M90.3,133.9c0.2-0.3,0.7-0.5,1-0.4c0.1,0,0.1,0.1,0.2,0.1
            c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0.1c-0.2,0.1-0.4,0.3-0.4,0.5c0,0.2,0.1,0.2,0.3,0.3c0.2,0,0.5-0.1,0.5-0.4
            c0-0.1,0.1-0.2,0.1-0.3c0.1,0.1,0.1,0.2,0.1,0.4c0,0.4-0.2,0.7-0.5,0.8c-0.4,0.2-0.7,0.1-1-0.1l-0.1-0.1
            C90,134.8,90,134.2,90.3,133.9z"
            />
            <path
              className="st8"
              d="M100.6,124c0.1,0.5,0.7,0.9,1.3,0.7c0.5-0.1,0.8-0.7,0.7-1.1c-0.1-0.4-0.1-0.5-0.3-0.7H101
            C100.7,123.1,100.5,123.6,100.6,124z M102.2,123.2c0.2,0.3,0.2,0.8,0,1.1c-0.2,0.3-0.7,0.4-1,0.3c-0.1,0-0.1-0.1-0.1-0.1
            c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.3,0.4-0.5c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.5,0.1-0.5,0.4c0,0.1-0.1,0.1-0.1,0.2
            c-0.1-0.2-0.2-0.4-0.1-0.7C100.9,122.9,101.6,122.7,102.2,123.2L102.2,123.2z"
            />
            <path
              className="st8"
              d="M91,144.5c0.4,0,0.9-0.5,1-0.9c0.1-0.6-0.4-1.2-1.1-1.2c-0.7,0.1-0.9,0.3-1,0.9c0,0.1,0,0.2,0.1,0.3
            C90,144.2,90.5,144.5,91,144.5z M90.3,142.9L90.3,142.9c0.4-0.3,0.9-0.3,1.2-0.1c0.3,0.2,0.5,0.7,0.3,1c0,0,0,0.1-0.1,0.1
            c0-0.1,0-0.2-0.1-0.2c-0.1-0.3-0.3-0.5-0.6-0.4c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.3,0.1,0.5,0.4,0.7c0.1,0,0.1,0,0.2,0.1
            c-0.2,0.2-0.4,0.2-0.6,0.1C90.1,144.1,89.9,143.5,90.3,142.9z"
            />
            <path
              className="st8"
              d="M101.6,128.9c0.7-0.1,0.9-0.3,1-0.9c0-0.1,0-0.2-0.1-0.3c-0.1-0.5-0.5-0.8-1.1-0.8c-0.4,0-0.9,0.5-1,0.9
            C100.5,128.3,101,128.9,101.6,128.9z M100.8,127.4C100.8,127.4,100.8,127.4,100.8,127.4c0.1,0.1,0.1,0.1,0.1,0.2
            c0.1,0.2,0.2,0.4,0.5,0.4s0.4-0.1,0.4-0.4c0-0.2-0.2-0.4-0.4-0.5c-0.1,0-0.1,0-0.2,0c0.2-0.2,0.4-0.2,0.6-0.1
            c0.7,0.2,0.8,0.9,0.5,1.4l-0.1,0.1c-0.3,0.2-0.8,0.2-1.1,0C100.8,128.3,100.6,127.8,100.8,127.4z"
            />
            <path
              className="st8"
              d="M104,131.3c0.4,0,0.8-0.4,1-0.8c0.1-0.6-0.3-1.3-0.9-1.3c-0.8-0.1-1,0.2-1.1,0.9
            C103,130.8,103.4,131.3,104,131.3z M104,129.5c0.7,0,1.1,0.7,0.7,1.3c0-0.1,0-0.2-0.1-0.2c-0.1-0.2-0.3-0.4-0.5-0.4
            s-0.3,0.1-0.3,0.3c0,0.2,0.2,0.5,0.4,0.5c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.2,0.1-0.3,0.1c-0.5,0.1-1-0.4-1-0.9
            C103.3,129.7,103.4,129.5,104,129.5z"
            />
            <path
              className="st8"
              d="M91,131.3c0.4,0,0.9-0.5,1-0.9c0.1-0.6-0.4-1.2-1.1-1.2c-0.7,0.1-0.9,0.3-1,0.9c0,0.1,0,0.2,0.1,0.3
            C90,131,90.5,131.3,91,131.3z M90.2,129.7c0-0.1,0.1-0.1,0.1-0.1c0.7-0.4,1.4,0,1.4,0.7c0,0.2,0,0.3-0.1,0.5c0-0.1,0-0.2-0.1-0.2
            c-0.1-0.2-0.3-0.4-0.5-0.4c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.2,0.5,0.4,0.5c0.1,0,0.1,0,0.2,0.1c-0.2,0.2-0.4,0.2-0.7,0.1
            C90.1,131,89.9,130.3,90.2,129.7z"
            />
            <path
              className="st8"
              d="M104.2,144.5c0.4,0,0.9-0.5,1-0.9c0.1-0.6-0.4-1.1-1.1-1.1c-0.7,0.1-0.9,0.3-1,1c0,0.1,0,0.2,0.1,0.3
            C103.1,144.2,103.6,144.5,104.2,144.5z M103.4,142.9c0-0.1,0.1-0.1,0.1-0.1c0.7-0.4,1.4,0,1.4,0.7c0,0.2,0,0.3-0.1,0.5
            c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.2,0.1-0.3,0.2c-0.1,0.2,0.1,0.5,0.4,0.6c0.1,0,0.1,0,0.2,0.1
            c-0.2,0.2-0.4,0.2-0.7,0.1C103.3,144.1,103.1,143.5,103.4,142.9z"
            />
            <path
              className="st8"
              d="M101.5,140c-0.4,0-0.9,0.5-1,0.9c-0.1,0.6,0.4,1.1,1.1,1.1c0.7-0.1,0.9-0.3,1-1c0-0.1,0-0.2-0.1-0.3
            C102.5,140.3,102,140,101.5,140z M102.2,141.6L102.2,141.6c-0.4,0.3-0.9,0.3-1.2,0.1c-0.3-0.2-0.5-0.7-0.3-1c0,0,0-0.1,0.1-0.1
            c0,0.1,0,0.2,0.1,0.2c0.1,0.2,0.2,0.4,0.5,0.4c0.2,0,0.4-0.1,0.4-0.4s-0.2-0.5-0.4-0.5c-0.1,0-0.1,0-0.2,0c0.2-0.2,0.4-0.2,0.6-0.1
            C102.4,140.3,102.5,141,102.2,141.6z"
            />
            <path
              className="st8"
              d="M110.2,124.7v-0.2c-0.4-0.2-0.5-0.8-0.2-1.3c0-0.1,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.1v-0.1h-0.3
            c-0.2,0.1-0.4,0.5-0.4,1C109.6,124.2,109.9,124.5,110.2,124.7z"
            />
            <path
              className="st8"
              d="M96.5,123.7c0,0.4,0.2,0.7,0.6,1c0.4,0.2,0.7,0.2,1-0.1c0.4-0.2,0.5-0.5,0.5-1c-0.1-0.3-0.2-0.6-0.5-0.7h-1.2
            C96.6,123,96.5,123.3,96.5,123.7z M97,123.1c0.3-0.2,0.7-0.2,1-0.1c0.3,0.2,0.5,0.5,0.5,0.8c0,0.1-0.1,0.2-0.1,0.4
            c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.2-0.3-0.4-0.5-0.4c-0.2,0-0.2,0.1-0.3,0.3c0,0.2,0.1,0.5,0.4,0.5c0.1,0,0.2,0.1,0.3,0.1
            c-0.2,0.1-0.4,0.2-0.6,0.1C97,124.5,96.5,123.9,97,123.1C96.8,123.2,96.9,123.1,97,123.1z"
            />
            <path
              className="st8"
              d="M97.4,135.9c-0.6,0.1-0.8,0.2-0.9,1c0,0.4,0.1,0.7,0.5,0.9c0.4,0.2,0.7,0.2,1,0.1c0.4-0.2,0.6-0.5,0.5-1
            C98.5,136.2,97.9,135.8,97.4,135.9z M98.3,137.4c0-0.1,0-0.2-0.1-0.2c-0.1-0.3-0.4-0.4-0.6-0.4c-0.2,0-0.2,0.1-0.2,0.2
            c-0.1,0.3,0.1,0.5,0.4,0.6c0.1,0,0.1,0,0.2,0.1c-0.2,0.2-0.5,0.2-0.7,0.1c-0.5-0.2-0.8-0.8-0.4-1.4c0-0.1,0.1-0.1,0.1-0.1
            c0.3-0.2,0.7-0.2,1-0.1c0.3,0.2,0.5,0.5,0.5,0.8C98.4,137.1,98.3,137.2,98.3,137.4z"
            />
            <path
              className="st8"
              d="M95.5,133.5c-0.3-0.2-0.7-0.2-1,0c-0.4,0.2-0.5,0.5-0.5,1c0.1,0.5,0.5,0.9,1,0.9c0.7,0,1-0.2,1.1-1
            C96.1,134.1,95.9,133.8,95.5,133.5z M95.8,135c0,0.1-0.1,0.1-0.1,0.1c-0.2,0.2-0.7,0.2-1,0.1c-0.3-0.2-0.5-0.5-0.4-0.9
            c0-0.1,0.1-0.2,0.1-0.2c0,0.1,0,0.1,0,0.1s0,0.1,0.1,0.2c0.1,0.2,0.4,0.4,0.6,0.3c0.2-0.1,0.2-0.1,0.2-0.3c0-0.2-0.1-0.5-0.3-0.5
            c-0.1-0.1-0.2-0.1-0.3-0.1c0.5-0.3,1.2,0.1,1.3,0.7C95.9,134.6,95.8,134.8,95.8,135z"
            />
            <path
              className="st8"
              d="M109.6,137c0.1,0.4,0.3,0.7,0.6,0.8v-0.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.2-0.4-0.1-0.7,0.1-1l0.1-0.1
            c0.1-0.1,0.1-0.1,0.2-0.1v-0.2C109.7,136,109.6,136.5,109.6,137z"
            />
            <path
              className="st8"
              d="M107.8,133.5c-0.4,0.1-0.7,0.6-0.7,1.1c0.1,0.5,0.4,0.9,1,0.9c0.8,0.1,1.1-0.2,1.1-1c-0.1-0.2-0.1-0.4-0.2-0.5
            C108.8,133.5,108.3,133.3,107.8,133.5z M108.9,135L108.9,135c-0.3,0.2-0.8,0.3-1.1,0.1c-0.3-0.2-0.5-0.5-0.4-0.8
            c0-0.1,0.1-0.2,0.1-0.3h0.1c0,0.1,0,0.1,0,0.1s0,0.1,0,0.1c0.1,0.2,0.3,0.4,0.5,0.4c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.5-0.4-0.6
            c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.4,0,0.6,0.2,0.8,0.5C109,134.4,109,134.7,108.9,135z"
            />
            <path className="st8" d="M95.4,122.2h-0.5V147h0.5V122.2z" />
            <path className="st8" d="M105.2,122.2h-0.5V147h0.5V122.2z" />
            <path className="st8" d="M100.2,44.3h-0.5V100h0.5V44.3z" />
          </g>
          <g id="circle2">
            <radialGradient
              id="SVGID_4_"
              cx="-418.4026"
              cy="602.4201"
              r="1"
              gradientTransform="matrix(55.8638 0 0 -55.9925 23491.6348 33773.0469)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: " #FFFFFF" }} />
              <stop offset="0.2982" style={{ stopColor: "#FAFAFA" }} />
              <stop offset="0.6473" style={{ stopColor: "#ECECEC" }} />
              <stop offset="1" style={{ stopColor: "#D6D6D6" }} />
            </radialGradient>
            <path
              className="st9"
              d="M110.5,39.7H92.3L79.3,52.6v18.3l12.9,12.9h18.2l12.9-12.9V52.6L110.5,39.7z"
            />
            <path
              className="st1"
              d="M110.2,40.3H92.5L79.9,52.9v17.8l12.6,12.5h17.7l12.6-12.5V52.9L110.2,40.3z"
            />
            <path
              className="st2"
              d="M109.1,43H93.6l-11,11v15.5l11,11h15.4l11-11V53.9L109.1,43z"
            />
            <path
              className="st7"
              d="M109.1,80.9H93.7c-0.1,0-0.2-0.1-0.4-0.2L82.5,69.8c-0.1-0.1-0.2-0.2-0.2-0.4V54c0-0.1,0.1-0.2,0.2-0.4
            l10.9-10.9c0.1-0.1,0.2-0.2,0.4-0.2h15.4c0.1,0,0.2,0.1,0.4,0.2l10.9,10.9c0.1,0.1,0.2,0.2,0.2,0.4v15.4c0,0.1-0.1,0.2-0.2,0.4
            l-10.9,10.9C109.3,80.8,109.2,80.9,109.1,80.9z M93.9,79.8h15l10.6-10.6V54.2l-10.6-10.6h-15L83.3,54.2v15L93.9,79.8z"
            />
            <path
              className="st7"
              d="M101.4,80.9c-0.1,0-0.2-0.1-0.3-0.1l-7.8-6.4c-0.1-0.1-0.2-0.2-0.2-0.4V49.5c0-0.2,0.1-0.3,0.2-0.4l7.8-6.4
            c0.2-0.2,0.5-0.2,0.7,0l7.8,6.4c0.1,0.1,0.2,0.2,0.2,0.4v24.4c0,0.2-0.1,0.3-0.2,0.4l-7.8,6.4C101.6,80.9,101.5,80.9,101.4,80.9z
             M94.1,73.7l7.3,6l7.3-6V49.8l-7.3-6l-7.3,6V73.7z"
            />
            <path
              className="st7"
              d="M113.5,70H89.2c-0.2,0-0.3-0.1-0.4-0.2l-6.4-7.8c-0.2-0.2-0.2-0.5,0-0.7l6.4-7.8c0.1-0.1,0.2-0.2,0.4-0.2h24.3
            c0.2,0,0.3,0.1,0.4,0.2l6.4,7.8c0.2,0.2,0.2,0.5,0,0.7l-6.4,7.8C113.8,70,113.7,70,113.5,70z M89.4,69h23.9l6-7.3l-6-7.3H89.4
            l-6,7.3L89.4,69z"
            />
            <path
              className="st7"
              d="M98.3,76.4C98.2,76.4,98.2,76.4,98.3,76.4l-10.1-1c-0.2,0-0.4-0.2-0.5-0.5l-1-10.1c0-0.2,0.1-0.3,0.1-0.4
            l17.2-17.2c0.1-0.1,0.2-0.2,0.4-0.1l10,1c0.2,0,0.4,0.2,0.5,0.5l1,10.1c0,0.2-0.1,0.3-0.1,0.4L98.6,76.2
            C98.5,76.3,98.4,76.4,98.3,76.4z M88.7,74.4l9.4,0.9L115,58.4l-0.9-9.4l-9.4-0.9L87.8,65L88.7,74.4z"
            />
            <path
              className="st7"
              d="M104.5,76.4c-0.1,0-0.2-0.1-0.4-0.2L86.9,58.9c-0.1-0.1-0.2-0.2-0.1-0.4l1-10.1c0-0.2,0.2-0.4,0.5-0.5l10-1
            c0.1,0,0.3,0.1,0.4,0.1l17.2,17.2c0.1,0.1,0.2,0.2,0.1,0.4l-1,10.1c0,0.2-0.2,0.4-0.5,0.5L104.5,76.4
            C104.5,76.4,104.5,76.4,104.5,76.4z M87.8,58.4l16.9,16.9l9.4-0.9L115,65L98.1,48.1L88.7,49L87.8,58.4z"
            />
          </g>
          <g id="circlegreen1">
            <radialGradient
              id="SVGID_5_"
              cx="-421.7062"
              cy="605.4521"
              r="1"
              gradientTransform="matrix(96.7035 0 0 -96.9264 40858.25 58700.0117)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: " #FFFFFF" }} />
              <stop offset="0.2982" style={{ stopColor: "#FAFAFA" }} />
              <stop offset="0.6473" style={{ stopColor: "#ECECEC" }} />
              <stop offset="1" style={{ stopColor: "#D6D6D6" }} />
            </radialGradient>
            <path
              className="st10"
              d="M64.6,11.6H33.1L10.8,33.9v31.6L33.1,88h31.6L87,65.6V33.9L64.6,11.6z"
            />
            <path
              className="st1"
              d="M64.2,12.6H33.6L11.8,34.4v30.7l21.8,21.7h30.6l21.7-21.7V34.4L64.2,12.6z"
            />
            <path
              className="st2"
              d="M62.3,17.3H35.5l-19,19v26.9l19,19h26.8l18.9-19V36.4L62.3,17.3z"
            />
            <path
              className="st3"
              d="M62.2,83H35.5c-0.2,0-0.5-0.1-0.7-0.2l-18.8-19c-0.2-0.2-0.2-0.4-0.2-0.7V36.4c0-0.2,0.1-0.5,0.2-0.7
            l18.8-18.9c0.2-0.2,0.4-0.2,0.7-0.2h26.7c0.2,0,0.5,0.1,0.7,0.2l18.8,18.9c0.2,0.2,0.2,0.4,0.2,0.7v26.7c0,0.2-0.1,0.5-0.2,0.7
            L62.8,82.7C62.7,82.9,62.5,83,62.2,83z M35.9,81.2h26l18.3-18.4v-26L61.9,18.4h-26L17.6,36.8v26L35.9,81.2z"
            />
            <path
              className="st3"
              d="M48.9,83c-0.2,0-0.4-0.1-0.6-0.2L34.9,71.6c-0.2-0.2-0.3-0.4-0.3-0.7V28.6c0-0.2,0.1-0.5,0.3-0.7l13.4-11.1
            c0.4-0.3,0.8-0.3,1.1,0L62.9,28c0.2,0.2,0.3,0.4,0.3,0.7v42.2c0,0.2-0.1,0.5-0.3,0.7L49.4,82.7C49.3,82.9,49.1,83,48.9,83z
             M36.3,70.5l12.6,10.4l12.6-10.4V29.1L48.9,18.6L36.3,29.1V70.5z"
            />
            <path
              className="st3"
              d="M70,64.2H27.8c-0.2,0-0.5-0.1-0.7-0.3L16,50.3c-0.3-0.4-0.3-0.8,0-1.1l11.1-13.5c0.2-0.2,0.4-0.3,0.7-0.3H70
            c0.2,0,0.5,0.1,0.7,0.3l11.1,13.5c0.3,0.4,0.3,0.8,0,1.1L70.6,63.8C70.4,64.1,70.2,64.2,70,64.2z M28.2,62.4h41.3l10.4-12.6
            L69.5,37.2H28.2L17.8,49.8L28.2,62.4z"
            />
            <path
              className="st3"
              d="M43.5,75.1L43.5,75.1L26,73.5c-0.4-0.1-0.8-0.4-0.8-0.8l-1.6-17.4c0-0.2,0.1-0.5,0.2-0.7l29.8-29.9
            c0.2-0.2,0.4-0.3,0.7-0.2l17.4,1.6c0.4,0.1,0.8,0.4,0.8,0.8l1.6,17.4c0,0.2-0.1,0.5-0.2,0.7L44.1,74.9
            C43.9,75.1,43.7,75.1,43.5,75.1z M26.9,71.8l16.2,1.6l29.2-29.3l-1.5-16.3l-16.2-1.6L25.4,55.5L26.9,71.8z"
            />
            <path
              className="st3"
              d="M54.3,75.1c-0.2,0-0.5-0.1-0.7-0.2L23.8,45c-0.2-0.2-0.3-0.5-0.2-0.7l1.6-17.4c0.1-0.4,0.4-0.8,0.8-0.8
            l17.4-1.6c0.3,0,0.5,0.1,0.7,0.2l29.8,29.9c0.2,0.2,0.3,0.5,0.2,0.7l-1.6,17.4c-0.1,0.4-0.4,0.8-0.8,0.8L54.3,75.1L54.3,75.1z
             M25.4,44.1l29.2,29.3l16.2-1.6l1.5-16.3L43.2,26.2l-16.2,1.6L25.4,44.1z"
            />
          </g>
        </svg>
      </a>
    </div>
  );
};
